/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.4.2.0 (NJsonSchema v10.1.11.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IGeneralServiceProxy {
    getAllReligion(): Observable<DropDownDto[]>;
    getAllOccupations(): Observable<DropDownDto[]>;
    getAllBanks(): Observable<DropDownDto[]>;
    getAllCities(): Observable<DropDownDto[]>;
    getAllCountries(): Observable<DropDownDto[]>;
    getAllDegrees(): Observable<DropDownDto[]>;
    getAllDepartments(): Observable<DropDownDto[]>;
    getAllCategoriesByDepartmentId(departmentId: number | undefined): Observable<DropDownDto[]>;
    getAllSubCategoriesByCategoryId(categoryId: number | undefined): Observable<DropDownDto[]>;
    getAllCharges(categoryId: number | undefined): Observable<DropDownDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class GeneralServiceProxy implements IGeneralServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getAllReligion(): Observable<DropDownDto[]> {
        let url_ = this.baseUrl + "/api/General/GetAllReligion";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllReligion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllReligion(<any>response_);
                } catch (e) {
                    return <Observable<DropDownDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DropDownDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllReligion(response: HttpResponseBase): Observable<DropDownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDownDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDownDto[]>(<any>null);
    }

    getAllOccupations(): Observable<DropDownDto[]> {
        let url_ = this.baseUrl + "/api/General/GetAllOccupations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllOccupations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllOccupations(<any>response_);
                } catch (e) {
                    return <Observable<DropDownDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DropDownDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllOccupations(response: HttpResponseBase): Observable<DropDownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDownDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDownDto[]>(<any>null);
    }

    getAllBanks(): Observable<DropDownDto[]> {
        let url_ = this.baseUrl + "/api/General/GetAllBanks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBanks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBanks(<any>response_);
                } catch (e) {
                    return <Observable<DropDownDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DropDownDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllBanks(response: HttpResponseBase): Observable<DropDownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDownDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDownDto[]>(<any>null);
    }

    getAllCities(): Observable<DropDownDto[]> {
        let url_ = this.baseUrl + "/api/General/GetAllCities";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCities(<any>response_);
                } catch (e) {
                    return <Observable<DropDownDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DropDownDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCities(response: HttpResponseBase): Observable<DropDownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDownDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDownDto[]>(<any>null);
    }

    getAllCountries(): Observable<DropDownDto[]> {
        let url_ = this.baseUrl + "/api/General/GetAllCountries";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCountries(<any>response_);
                } catch (e) {
                    return <Observable<DropDownDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DropDownDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCountries(response: HttpResponseBase): Observable<DropDownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDownDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDownDto[]>(<any>null);
    }

    getAllDegrees(): Observable<DropDownDto[]> {
        let url_ = this.baseUrl + "/api/General/GetAllDegrees";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDegrees(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDegrees(<any>response_);
                } catch (e) {
                    return <Observable<DropDownDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DropDownDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllDegrees(response: HttpResponseBase): Observable<DropDownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDownDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDownDto[]>(<any>null);
    }

    getAllDepartments(): Observable<DropDownDto[]> {
        let url_ = this.baseUrl + "/api/General/GetAllDepartments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDepartments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDepartments(<any>response_);
                } catch (e) {
                    return <Observable<DropDownDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DropDownDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllDepartments(response: HttpResponseBase): Observable<DropDownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDownDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDownDto[]>(<any>null);
    }

    getAllCategoriesByDepartmentId(departmentId: number | undefined): Observable<DropDownDto[]> {
        let url_ = this.baseUrl + "/api/General/GetAllCategoriesByDepartmentId?";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCategoriesByDepartmentId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCategoriesByDepartmentId(<any>response_);
                } catch (e) {
                    return <Observable<DropDownDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DropDownDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCategoriesByDepartmentId(response: HttpResponseBase): Observable<DropDownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDownDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDownDto[]>(<any>null);
    }

    getAllSubCategoriesByCategoryId(categoryId: number | undefined): Observable<DropDownDto[]> {
        let url_ = this.baseUrl + "/api/General/GetAllSubCategoriesByCategoryId?";
        if (categoryId === null)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSubCategoriesByCategoryId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSubCategoriesByCategoryId(<any>response_);
                } catch (e) {
                    return <Observable<DropDownDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DropDownDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSubCategoriesByCategoryId(response: HttpResponseBase): Observable<DropDownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDownDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDownDto[]>(<any>null);
    }

    getAllCharges(categoryId: number | undefined): Observable<DropDownDto[]> {
        let url_ = this.baseUrl + "/api/General/GetAllCharges?";
        if (categoryId === null)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCharges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCharges(<any>response_);
                } catch (e) {
                    return <Observable<DropDownDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DropDownDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCharges(response: HttpResponseBase): Observable<DropDownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDownDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDownDto[]>(<any>null);
    }
}

export interface IMenteeServiceProxy {
    update(request: UpdateMenteeCommand): Observable<string>;
    getMenteeProfile(): Observable<CreateOrUpdateMenteeDto>;
    getMenteesForView(): Observable<MenteesViewDto[]>;
    getMenteesForViewById(menteeId: number | undefined): Observable<MenteesViewDto>;
}

@Injectable({
    providedIn: 'root'
})
export class MenteeServiceProxy implements IMenteeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    update(request: UpdateMenteeCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Mentee/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    getMenteeProfile(): Observable<CreateOrUpdateMenteeDto> {
        let url_ = this.baseUrl + "/api/Mentee/GetMenteeProfile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMenteeProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMenteeProfile(<any>response_);
                } catch (e) {
                    return <Observable<CreateOrUpdateMenteeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateOrUpdateMenteeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetMenteeProfile(response: HttpResponseBase): Observable<CreateOrUpdateMenteeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdateMenteeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrUpdateMenteeDto>(<any>null);
    }

    getMenteesForView(): Observable<MenteesViewDto[]> {
        let url_ = this.baseUrl + "/api/Mentee/GetMenteesForView";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMenteesForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMenteesForView(<any>response_);
                } catch (e) {
                    return <Observable<MenteesViewDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MenteesViewDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetMenteesForView(response: HttpResponseBase): Observable<MenteesViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MenteesViewDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MenteesViewDto[]>(<any>null);
    }

    getMenteesForViewById(menteeId: number | undefined): Observable<MenteesViewDto> {
        let url_ = this.baseUrl + "/api/Mentee/GetMenteesForViewById?";
        if (menteeId === null)
            throw new Error("The parameter 'menteeId' cannot be null.");
        else if (menteeId !== undefined)
            url_ += "menteeId=" + encodeURIComponent("" + menteeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMenteesForViewById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMenteesForViewById(<any>response_);
                } catch (e) {
                    return <Observable<MenteesViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MenteesViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetMenteesForViewById(response: HttpResponseBase): Observable<MenteesViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MenteesViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MenteesViewDto>(<any>null);
    }
}

export interface IMentorServiceProxy {
    updateMentor(request: UpdateMentorCommand): Observable<string>;
    getMentoreProfile(): Observable<CreateOrUpdateMentorDto>;
    getMentoreProfileById(mentorId: number | undefined): Observable<MentorDto>;
    gellAllMentors(departmentId: number | null | undefined, categoryId: number | null | undefined, subCategory: number | null | undefined, countryid: number | null | undefined, city: string | null | undefined, profession: number | null | undefined, charges: number | null | undefined, filter: string | null | undefined): Observable<MentorViewDto[]>;
    getAllMentorsCharages(): Observable<MentorCharageDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class MentorServiceProxy implements IMentorServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    updateMentor(request: UpdateMentorCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Mentor/UpdateMentor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMentor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMentor(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateMentor(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    getMentoreProfile(): Observable<CreateOrUpdateMentorDto> {
        let url_ = this.baseUrl + "/api/Mentor/GetMentoreProfile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMentoreProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMentoreProfile(<any>response_);
                } catch (e) {
                    return <Observable<CreateOrUpdateMentorDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateOrUpdateMentorDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetMentoreProfile(response: HttpResponseBase): Observable<CreateOrUpdateMentorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdateMentorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrUpdateMentorDto>(<any>null);
    }

    getMentoreProfileById(mentorId: number | undefined): Observable<MentorDto> {
        let url_ = this.baseUrl + "/api/Mentor/GetMentoreProfileById?";
        if (mentorId === null)
            throw new Error("The parameter 'mentorId' cannot be null.");
        else if (mentorId !== undefined)
            url_ += "mentorId=" + encodeURIComponent("" + mentorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMentoreProfileById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMentoreProfileById(<any>response_);
                } catch (e) {
                    return <Observable<MentorDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MentorDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetMentoreProfileById(response: HttpResponseBase): Observable<MentorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MentorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MentorDto>(<any>null);
    }

    gellAllMentors(departmentId: number | null | undefined, categoryId: number | null | undefined, subCategory: number | null | undefined, countryid: number | null | undefined, city: string | null | undefined, profession: number | null | undefined, charges: number | null | undefined, filter: string | null | undefined): Observable<MentorViewDto[]> {
        let url_ = this.baseUrl + "/api/Mentor/GetAllMentors?";
        if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        if (subCategory !== undefined)
            url_ += "subCategory=" + encodeURIComponent("" + subCategory) + "&";
        if (countryid !== undefined)
            url_ += "countryid=" + encodeURIComponent("" + countryid) + "&";
        if (city !== undefined)
            url_ += "city=" + encodeURIComponent("" + city) + "&";
        if (profession !== undefined)
            url_ += "profession=" + encodeURIComponent("" + profession) + "&";
        if (charges !== undefined)
            url_ += "charges=" + encodeURIComponent("" + charges) + "&";
        if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGellAllMentors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGellAllMentors(<any>response_);
                } catch (e) {
                    return <Observable<MentorViewDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MentorViewDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGellAllMentors(response: HttpResponseBase): Observable<MentorViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MentorViewDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MentorViewDto[]>(<any>null);
    }

    getAllMentorsCharages(): Observable<MentorCharageDto[]> {
        let url_ = this.baseUrl + "/api/Mentor/GetAllMentorsCharages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMentorsCharages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMentorsCharages(<any>response_);
                } catch (e) {
                    return <Observable<MentorCharageDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MentorCharageDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllMentorsCharages(response: HttpResponseBase): Observable<MentorCharageDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MentorCharageDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MentorCharageDto[]>(<any>null);
    }
}

export interface IAccountServiceProxy {
    logIn(request: LoginQuery): Observable<LoginResponse>;
    signup(signUp: SignUpCommand): Observable<SignUpResponse>;
    signupWithLogin(signUp: SignUpWithLoginCommand): Observable<LoginResponse>;
    isEmailExist(emailAddress: string | null | undefined): Observable<boolean>;
    isMobilePhoneExist(mobileNo: string | null | undefined): Observable<boolean>;
    logOut(request: LogoutQuery): Observable<string>;
    getUserProfilePicture(userId: string | null | undefined): Observable<GetProfilePictureOutput>;
    getProfilePictureById(profilePictureId: string | null | undefined): Observable<GetProfilePictureOutput>;
    changePassword(oldPassword: string | null | undefined, newPassword: string | null | undefined, confirmNewPassword: string | null | undefined): Observable<LoginResponse>;
    forgotPassword(emailAddress: string | null | undefined): Observable<boolean>;
    resetPassword(userId: string | null | undefined, resetToken: string | null | undefined, newPassword: string | null | undefined, confirmNewPassword: string | null | undefined): Observable<Result>;
}

@Injectable({
    providedIn: 'root'
})
export class AccountServiceProxy implements IAccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    logIn(request: LoginQuery): Observable<LoginResponse> {
        let url_ = this.baseUrl + "/api/Account/Login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogIn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogIn(<any>response_);
                } catch (e) {
                    return <Observable<LoginResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoginResponse>><any>_observableThrow(response_);
        }));
    }

    protected processLogIn(response: HttpResponseBase): Observable<LoginResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoginResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoginResponse>(<any>null);
    }

    signup(signUp: SignUpCommand): Observable<SignUpResponse> {
        let url_ = this.baseUrl + "/api/Account/Signup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(signUp);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSignup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSignup(<any>response_);
                } catch (e) {
                    return <Observable<SignUpResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<SignUpResponse>><any>_observableThrow(response_);
        }));
    }

    protected processSignup(response: HttpResponseBase): Observable<SignUpResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SignUpResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SignUpResponse>(<any>null);
    }

    signupWithLogin(signUp: SignUpWithLoginCommand): Observable<LoginResponse> {
        let url_ = this.baseUrl + "/api/Account/SignupWithLogin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(signUp);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSignupWithLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSignupWithLogin(<any>response_);
                } catch (e) {
                    return <Observable<LoginResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoginResponse>><any>_observableThrow(response_);
        }));
    }

    protected processSignupWithLogin(response: HttpResponseBase): Observable<LoginResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoginResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoginResponse>(<any>null);
    }

    isEmailExist(emailAddress: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Account/IsEmailExist?";
        if (emailAddress !== undefined)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsEmailExist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsEmailExist(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processIsEmailExist(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    isMobilePhoneExist(mobileNo: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Account/IsMobilePhoneExist?";
        if (mobileNo !== undefined)
            url_ += "mobileNo=" + encodeURIComponent("" + mobileNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsMobilePhoneExist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsMobilePhoneExist(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processIsMobilePhoneExist(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    logOut(request: LogoutQuery): Observable<string> {
        let url_ = this.baseUrl + "/api/Account/Logout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogOut(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processLogOut(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    getUserProfilePicture(userId: string | null | undefined): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/Account/GetUserProfilePicture?";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserProfilePicture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserProfilePicture(<any>response_);
                } catch (e) {
                    return <Observable<GetProfilePictureOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetProfilePictureOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserProfilePicture(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfilePictureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProfilePictureOutput>(<any>null);
    }

    getProfilePictureById(profilePictureId: string | null | undefined): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/Account/GetProfilePictureById?";
        if (profilePictureId !== undefined)
            url_ += "profilePictureId=" + encodeURIComponent("" + profilePictureId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfilePictureById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfilePictureById(<any>response_);
                } catch (e) {
                    return <Observable<GetProfilePictureOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetProfilePictureOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetProfilePictureById(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfilePictureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProfilePictureOutput>(<any>null);
    }

    changePassword(oldPassword: string | null | undefined, newPassword: string | null | undefined, confirmNewPassword: string | null | undefined): Observable<LoginResponse> {
        let url_ = this.baseUrl + "/api/Account/ChangePassword?";
        if (oldPassword !== undefined)
            url_ += "oldPassword=" + encodeURIComponent("" + oldPassword) + "&";
        if (newPassword !== undefined)
            url_ += "newPassword=" + encodeURIComponent("" + newPassword) + "&";
        if (confirmNewPassword !== undefined)
            url_ += "confirmNewPassword=" + encodeURIComponent("" + confirmNewPassword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(<any>response_);
                } catch (e) {
                    return <Observable<LoginResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoginResponse>><any>_observableThrow(response_);
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<LoginResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoginResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoginResponse>(<any>null);
    }

    forgotPassword(emailAddress: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Account/ForgotPassword?";
        if (emailAddress !== undefined)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForgotPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForgotPassword(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processForgotPassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    resetPassword(userId: string | null | undefined, resetToken: string | null | undefined, newPassword: string | null | undefined, confirmNewPassword: string | null | undefined): Observable<Result> {
        let url_ = this.baseUrl + "/api/Account/ResetPassword?";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (resetToken !== undefined)
            url_ += "resetToken=" + encodeURIComponent("" + resetToken) + "&";
        if (newPassword !== undefined)
            url_ += "newPassword=" + encodeURIComponent("" + newPassword) + "&";
        if (confirmNewPassword !== undefined)
            url_ += "confirmNewPassword=" + encodeURIComponent("" + confirmNewPassword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(<any>response_);
                } catch (e) {
                    return <Observable<Result>><any>_observableThrow(e);
                }
            } else
                return <Observable<Result>><any>_observableThrow(response_);
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(<any>null);
    }
}

export interface IAdminServiceProxy {
    getAllAppointments(): Observable<AppointmentDto[]>;
    getAdminDashboadInfo(): Observable<AdminDashboardDto>;
    approveAndRejectMentor(bit: boolean | undefined, mentorID: number | undefined): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class AdminServiceProxy implements IAdminServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getAllAppointments(): Observable<AppointmentDto[]> {
        let url_ = this.baseUrl + "/api/Admin/GetAllAppointments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAppointments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAppointments(<any>response_);
                } catch (e) {
                    return <Observable<AppointmentDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AppointmentDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllAppointments(response: HttpResponseBase): Observable<AppointmentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppointmentDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AppointmentDto[]>(<any>null);
    }

    getAdminDashboadInfo(): Observable<AdminDashboardDto> {
        let url_ = this.baseUrl + "/api/Admin/GetAdminDashboadInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdminDashboadInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdminDashboadInfo(<any>response_);
                } catch (e) {
                    return <Observable<AdminDashboardDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AdminDashboardDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAdminDashboadInfo(response: HttpResponseBase): Observable<AdminDashboardDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminDashboardDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AdminDashboardDto>(<any>null);
    }

    approveAndRejectMentor(bit: boolean | undefined, mentorID: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Admin/ApproveAndRejectMentor?";
        if (bit === null)
            throw new Error("The parameter 'bit' cannot be null.");
        else if (bit !== undefined)
            url_ += "bit=" + encodeURIComponent("" + bit) + "&";
        if (mentorID === null)
            throw new Error("The parameter 'mentorID' cannot be null.");
        else if (mentorID !== undefined)
            url_ += "MentorID=" + encodeURIComponent("" + mentorID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveAndRejectMentor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveAndRejectMentor(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processApproveAndRejectMentor(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

export interface IAppointmentServiceProxy {
    createAppointment(input: CreateOrEditAppointmentDto): Observable<CreatePaymentDto>;
    getAllAppointmentsByMentee(menteeId: number | undefined, isCompleted: boolean | undefined): Observable<AppointmentDto[]>;
    getAllAppointmentsByMentor(mentorId: number | undefined, isCompleted: boolean | undefined, isToday: boolean | undefined): Observable<AppointmentDto[]>;
    getAppointmentsForView(appointmentId: number | undefined): Observable<AppointmentForViewDto>;
    appointmentStatusChange(appintmentID: number | undefined, status: string | null | undefined): Observable<boolean>;
    getAppointmentViewForInvoiceByID(appointmentId: number | undefined): Observable<AppointmentForViewDto>;
}

@Injectable({
    providedIn: 'root'
})
export class AppointmentServiceProxy implements IAppointmentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    createAppointment(input: CreateOrEditAppointmentDto): Observable<CreatePaymentDto> {
        let url_ = this.baseUrl + "/api/Appointment/CreateAppointment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAppointment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAppointment(<any>response_);
                } catch (e) {
                    return <Observable<CreatePaymentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreatePaymentDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateAppointment(response: HttpResponseBase): Observable<CreatePaymentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreatePaymentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreatePaymentDto>(<any>null);
    }

    getAllAppointmentsByMentee(menteeId: number | undefined, isCompleted: boolean | undefined): Observable<AppointmentDto[]> {
        let url_ = this.baseUrl + "/api/Appointment/GetAllAppointmentsByMentee?";
        if (menteeId === null)
            throw new Error("The parameter 'menteeId' cannot be null.");
        else if (menteeId !== undefined)
            url_ += "menteeId=" + encodeURIComponent("" + menteeId) + "&";
        if (isCompleted === null)
            throw new Error("The parameter 'isCompleted' cannot be null.");
        else if (isCompleted !== undefined)
            url_ += "isCompleted=" + encodeURIComponent("" + isCompleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAppointmentsByMentee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAppointmentsByMentee(<any>response_);
                } catch (e) {
                    return <Observable<AppointmentDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AppointmentDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllAppointmentsByMentee(response: HttpResponseBase): Observable<AppointmentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppointmentDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AppointmentDto[]>(<any>null);
    }

    getAllAppointmentsByMentor(mentorId: number | undefined, isCompleted: boolean | undefined, isToday: boolean | undefined): Observable<AppointmentDto[]> {
        let url_ = this.baseUrl + "/api/Appointment/GetAllAppointmentsByMentor?";
        if (mentorId === null)
            throw new Error("The parameter 'mentorId' cannot be null.");
        else if (mentorId !== undefined)
            url_ += "mentorId=" + encodeURIComponent("" + mentorId) + "&";
        if (isCompleted === null)
            throw new Error("The parameter 'isCompleted' cannot be null.");
        else if (isCompleted !== undefined)
            url_ += "isCompleted=" + encodeURIComponent("" + isCompleted) + "&";
        if (isToday === null)
            throw new Error("The parameter 'isToday' cannot be null.");
        else if (isToday !== undefined)
            url_ += "isToday=" + encodeURIComponent("" + isToday) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAppointmentsByMentor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAppointmentsByMentor(<any>response_);
                } catch (e) {
                    return <Observable<AppointmentDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AppointmentDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllAppointmentsByMentor(response: HttpResponseBase): Observable<AppointmentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppointmentDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AppointmentDto[]>(<any>null);
    }

    getAppointmentsForView(appointmentId: number | undefined): Observable<AppointmentForViewDto> {
        let url_ = this.baseUrl + "/api/Appointment/GetAppointmentsForView?";
        if (appointmentId === null)
            throw new Error("The parameter 'appointmentId' cannot be null.");
        else if (appointmentId !== undefined)
            url_ += "AppointmentId=" + encodeURIComponent("" + appointmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppointmentsForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppointmentsForView(<any>response_);
                } catch (e) {
                    return <Observable<AppointmentForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AppointmentForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAppointmentsForView(response: HttpResponseBase): Observable<AppointmentForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppointmentForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AppointmentForViewDto>(<any>null);
    }

    appointmentStatusChange(appintmentID: number | undefined, status: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Appointment/AppointmentStatusChange?";
        if (appintmentID === null)
            throw new Error("The parameter 'appintmentID' cannot be null.");
        else if (appintmentID !== undefined)
            url_ += "AppintmentID=" + encodeURIComponent("" + appintmentID) + "&";
        if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppointmentStatusChange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppointmentStatusChange(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processAppointmentStatusChange(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    getAppointmentViewForInvoiceByID(appointmentId: number | undefined): Observable<AppointmentForViewDto> {
        let url_ = this.baseUrl + "/api/Appointment/GetAppointmentViewForInvoiceByID?";
        if (appointmentId === null)
            throw new Error("The parameter 'appointmentId' cannot be null.");
        else if (appointmentId !== undefined)
            url_ += "AppointmentId=" + encodeURIComponent("" + appointmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppointmentViewForInvoiceByID(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppointmentViewForInvoiceByID(<any>response_);
                } catch (e) {
                    return <Observable<AppointmentForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AppointmentForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAppointmentViewForInvoiceByID(response: HttpResponseBase): Observable<AppointmentForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppointmentForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AppointmentForViewDto>(<any>null);
    }
}

export interface ICategoryServiceProxy {
    getAllCategories(pageNumber: number | undefined, pageSize: number | undefined): Observable<CategoryDto[]>;
    getCategoryForEdit(categoryID: number | undefined): Observable<CatgoryDtOForEdit>;
    deleteCategory(categoryID: number | undefined): Observable<boolean>;
    upsertCategory(id: number | null | undefined, name: string | null | undefined, departmentId: number | undefined): Observable<number>;
    getAllSubCategories(): Observable<SubCategoryForViewDtocs[]>;
    upsertSubCategory(input: CreateOrUpdateSubCategoryDto): Observable<number>;
    deleteSubCategory(subcategoryID: number | undefined): Observable<boolean>;
    getSubCategoryForEdit(subcategoryID: number | undefined): Observable<SubCategoryForEditDto>;
}

@Injectable({
    providedIn: 'root'
})
export class CategoryServiceProxy implements ICategoryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getAllCategories(pageNumber: number | undefined, pageSize: number | undefined): Observable<CategoryDto[]> {
        let url_ = this.baseUrl + "/api/Category/GetAllCategories?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCategories(<any>response_);
                } catch (e) {
                    return <Observable<CategoryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CategoryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCategories(response: HttpResponseBase): Observable<CategoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CategoryDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CategoryDto[]>(<any>null);
    }

    getCategoryForEdit(categoryID: number | undefined): Observable<CatgoryDtOForEdit> {
        let url_ = this.baseUrl + "/api/Category/GetCategoryForEdit?";
        if (categoryID === null)
            throw new Error("The parameter 'categoryID' cannot be null.");
        else if (categoryID !== undefined)
            url_ += "categoryID=" + encodeURIComponent("" + categoryID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCategoryForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategoryForEdit(<any>response_);
                } catch (e) {
                    return <Observable<CatgoryDtOForEdit>><any>_observableThrow(e);
                }
            } else
                return <Observable<CatgoryDtOForEdit>><any>_observableThrow(response_);
        }));
    }

    protected processGetCategoryForEdit(response: HttpResponseBase): Observable<CatgoryDtOForEdit> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CatgoryDtOForEdit.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CatgoryDtOForEdit>(<any>null);
    }

    deleteCategory(categoryID: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Category/DeleteCategory?";
        if (categoryID === null)
            throw new Error("The parameter 'categoryID' cannot be null.");
        else if (categoryID !== undefined)
            url_ += "categoryID=" + encodeURIComponent("" + categoryID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCategory(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteCategory(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    upsertCategory(id: number | null | undefined, name: string | null | undefined, departmentId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/Category/UpsertCategory?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertCategory(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUpsertCategory(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    getAllSubCategories(): Observable<SubCategoryForViewDtocs[]> {
        let url_ = this.baseUrl + "/api/Category/GetAllSubCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSubCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSubCategories(<any>response_);
                } catch (e) {
                    return <Observable<SubCategoryForViewDtocs[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SubCategoryForViewDtocs[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSubCategories(response: HttpResponseBase): Observable<SubCategoryForViewDtocs[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubCategoryForViewDtocs.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubCategoryForViewDtocs[]>(<any>null);
    }

    upsertSubCategory(input: CreateOrUpdateSubCategoryDto): Observable<number> {
        let url_ = this.baseUrl + "/api/Category/UpsertSubCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertSubCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertSubCategory(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUpsertSubCategory(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    deleteSubCategory(subcategoryID: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Category/DeleteSubCategory?";
        if (subcategoryID === null)
            throw new Error("The parameter 'subcategoryID' cannot be null.");
        else if (subcategoryID !== undefined)
            url_ += "subcategoryID=" + encodeURIComponent("" + subcategoryID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSubCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSubCategory(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteSubCategory(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    getSubCategoryForEdit(subcategoryID: number | undefined): Observable<SubCategoryForEditDto> {
        let url_ = this.baseUrl + "/api/Category/GetSubCategoryForEdit?";
        if (subcategoryID === null)
            throw new Error("The parameter 'subcategoryID' cannot be null.");
        else if (subcategoryID !== undefined)
            url_ += "subcategoryID=" + encodeURIComponent("" + subcategoryID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubCategoryForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubCategoryForEdit(<any>response_);
                } catch (e) {
                    return <Observable<SubCategoryForEditDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SubCategoryForEditDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSubCategoryForEdit(response: HttpResponseBase): Observable<SubCategoryForEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubCategoryForEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubCategoryForEditDto>(<any>null);
    }
}

export interface IDashboardServiceProxy {
    getMentorDashboard(): Observable<DashboardViewDto>;
    getMenteeDashboard(): Observable<DashboardViewDto>;
}

@Injectable({
    providedIn: 'root'
})
export class DashboardServiceProxy implements IDashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getMentorDashboard(): Observable<DashboardViewDto> {
        let url_ = this.baseUrl + "/api/Dashboard/GetMentorDashboard";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMentorDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMentorDashboard(<any>response_);
                } catch (e) {
                    return <Observable<DashboardViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DashboardViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetMentorDashboard(response: HttpResponseBase): Observable<DashboardViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DashboardViewDto>(<any>null);
    }

    getMenteeDashboard(): Observable<DashboardViewDto> {
        let url_ = this.baseUrl + "/api/Dashboard/GetMenteeDashboard";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMenteeDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMenteeDashboard(<any>response_);
                } catch (e) {
                    return <Observable<DashboardViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DashboardViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetMenteeDashboard(response: HttpResponseBase): Observable<DashboardViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DashboardViewDto>(<any>null);
    }
}

export interface IDegreeServiceProxy {
    createOrEditDegree(id: number | null | undefined, name: string | null | undefined): Observable<string>;
    deleteDegree(id: number | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class DegreeServiceProxy implements IDegreeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    createOrEditDegree(id: number | null | undefined, name: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Degree/CreateOrEditDegree?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditDegree(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditDegree(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditDegree(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    deleteDegree(id: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Degree/DeleteDegree?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDegree(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDegree(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteDegree(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

export interface IDepartmentServiceProxy {
    upsertDepartment(input: CreateOrEditDepartment): Observable<CreateOrEditDepartment>;
    deleteDepartment(departmentId: number | undefined): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class DepartmentServiceProxy implements IDepartmentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    upsertDepartment(input: CreateOrEditDepartment): Observable<CreateOrEditDepartment> {
        let url_ = this.baseUrl + "/api/Department/UpsertDepartment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertDepartment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertDepartment(<any>response_);
                } catch (e) {
                    return <Observable<CreateOrEditDepartment>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateOrEditDepartment>><any>_observableThrow(response_);
        }));
    }

    protected processUpsertDepartment(response: HttpResponseBase): Observable<CreateOrEditDepartment> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditDepartment.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditDepartment>(<any>null);
    }

    deleteDepartment(departmentId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Department/DeleteDepartment?";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDepartment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDepartment(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteDepartment(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

export interface IOccuptionServiceProxy {
    createOrEditOccuption(id: number | null | undefined, name: string | null | undefined): Observable<string>;
    deleteOccuption(id: number | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class OccuptionServiceProxy implements IOccuptionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    createOrEditOccuption(id: number | null | undefined, name: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Occuption/CreateOrEditOccuption?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditOccuption(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditOccuption(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditOccuption(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    deleteOccuption(id: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Occuption/DeleteOccuption?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteOccuption(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOccuption(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteOccuption(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

export interface IPaymentServiceProxy {
    getInvoice(id: number | undefined): Observable<InvoiceDto>;
    createPayment(createPaymentDto: CreatePaymentDto): Observable<number>;
    getActiveGateways(): Observable<PaymentGatewayModel[]>;
}

@Injectable({
    providedIn: 'root'
})
export class PaymentServiceProxy implements IPaymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getInvoice(id: number | undefined): Observable<InvoiceDto> {
        let url_ = this.baseUrl + "/api/Payment/GetInvoice?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoice(<any>response_);
                } catch (e) {
                    return <Observable<InvoiceDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<InvoiceDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetInvoice(response: HttpResponseBase): Observable<InvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceDto>(<any>null);
    }

    createPayment(createPaymentDto: CreatePaymentDto): Observable<number> {
        let url_ = this.baseUrl + "/api/Payment/CreatePayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createPaymentDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePayment(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreatePayment(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    getActiveGateways(): Observable<PaymentGatewayModel[]> {
        let url_ = this.baseUrl + "/api/Payment/GetActiveGateways";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveGateways(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveGateways(<any>response_);
                } catch (e) {
                    return <Observable<PaymentGatewayModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaymentGatewayModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetActiveGateways(response: HttpResponseBase): Observable<PaymentGatewayModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PaymentGatewayModel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentGatewayModel[]>(<any>null);
    }
}

export interface IQuestionServiceProxy {
    create(request: CreateQuestionCommand): Observable<number>;
    update(request: UpdateQuestionCommand): Observable<number>;
    selectMentor(request: SelectMentorQuestionCommand): Observable<QuestionDto>;
    createQuestionResponce(request: CreateQuestionResponceCommand): Observable<QuestionResponceForViewDto>;
    updateQuestionRating(questionId: number | undefined, rating: number | undefined): Observable<boolean>;
    getDetailForPayment(questionId: number | undefined, mentorId: number | undefined): Observable<QuestionDto>;
    getAllQuestionsByMentee(menteeId: number | undefined, isAnswered: boolean | undefined): Observable<QuestionForViewDto[]>;
    getAllQuestionsByMentor(mentorId: number | undefined, isAnswered: boolean | undefined): Observable<QuestionForViewDto[]>;
    getQuestionDetailForView(id: number | undefined): Observable<QuestionForViewDto>;
    getQuestionDetailForEdit(id: number | undefined): Observable<CreateOrEditQuestionDto>;
    getAllQuestionDetailForView(): Observable<QuestionViewDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class QuestionServiceProxy implements IQuestionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    create(request: CreateQuestionCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Question/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    update(request: UpdateQuestionCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Question/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    selectMentor(request: SelectMentorQuestionCommand): Observable<QuestionDto> {
        let url_ = this.baseUrl + "/api/Question/selectmentor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSelectMentor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSelectMentor(<any>response_);
                } catch (e) {
                    return <Observable<QuestionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<QuestionDto>><any>_observableThrow(response_);
        }));
    }

    protected processSelectMentor(response: HttpResponseBase): Observable<QuestionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuestionDto>(<any>null);
    }

    createQuestionResponce(request: CreateQuestionResponceCommand): Observable<QuestionResponceForViewDto> {
        let url_ = this.baseUrl + "/api/Question/CreateQuestionResponce";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateQuestionResponce(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateQuestionResponce(<any>response_);
                } catch (e) {
                    return <Observable<QuestionResponceForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<QuestionResponceForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateQuestionResponce(response: HttpResponseBase): Observable<QuestionResponceForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionResponceForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuestionResponceForViewDto>(<any>null);
    }

    updateQuestionRating(questionId: number | undefined, rating: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Question/UpdateQuestionRating?";
        if (questionId === null)
            throw new Error("The parameter 'questionId' cannot be null.");
        else if (questionId !== undefined)
            url_ += "questionId=" + encodeURIComponent("" + questionId) + "&";
        if (rating === null)
            throw new Error("The parameter 'rating' cannot be null.");
        else if (rating !== undefined)
            url_ += "rating=" + encodeURIComponent("" + rating) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateQuestionRating(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateQuestionRating(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateQuestionRating(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    getDetailForPayment(questionId: number | undefined, mentorId: number | undefined): Observable<QuestionDto> {
        let url_ = this.baseUrl + "/api/Question/GetDetailForPayment?";
        if (questionId === null)
            throw new Error("The parameter 'questionId' cannot be null.");
        else if (questionId !== undefined)
            url_ += "questionId=" + encodeURIComponent("" + questionId) + "&";
        if (mentorId === null)
            throw new Error("The parameter 'mentorId' cannot be null.");
        else if (mentorId !== undefined)
            url_ += "mentorId=" + encodeURIComponent("" + mentorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetailForPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetailForPayment(<any>response_);
                } catch (e) {
                    return <Observable<QuestionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<QuestionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetDetailForPayment(response: HttpResponseBase): Observable<QuestionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuestionDto>(<any>null);
    }

    getAllQuestionsByMentee(menteeId: number | undefined, isAnswered: boolean | undefined): Observable<QuestionForViewDto[]> {
        let url_ = this.baseUrl + "/api/Question/GetAllQuestionsByMentee?";
        if (menteeId === null)
            throw new Error("The parameter 'menteeId' cannot be null.");
        else if (menteeId !== undefined)
            url_ += "menteeId=" + encodeURIComponent("" + menteeId) + "&";
        if (isAnswered === null)
            throw new Error("The parameter 'isAnswered' cannot be null.");
        else if (isAnswered !== undefined)
            url_ += "isAnswered=" + encodeURIComponent("" + isAnswered) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllQuestionsByMentee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllQuestionsByMentee(<any>response_);
                } catch (e) {
                    return <Observable<QuestionForViewDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<QuestionForViewDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllQuestionsByMentee(response: HttpResponseBase): Observable<QuestionForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QuestionForViewDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuestionForViewDto[]>(<any>null);
    }

    getAllQuestionsByMentor(mentorId: number | undefined, isAnswered: boolean | undefined): Observable<QuestionForViewDto[]> {
        let url_ = this.baseUrl + "/api/Question/GetAllQuestionsByMentor?";
        if (mentorId === null)
            throw new Error("The parameter 'mentorId' cannot be null.");
        else if (mentorId !== undefined)
            url_ += "mentorId=" + encodeURIComponent("" + mentorId) + "&";
        if (isAnswered === null)
            throw new Error("The parameter 'isAnswered' cannot be null.");
        else if (isAnswered !== undefined)
            url_ += "isAnswered=" + encodeURIComponent("" + isAnswered) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllQuestionsByMentor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllQuestionsByMentor(<any>response_);
                } catch (e) {
                    return <Observable<QuestionForViewDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<QuestionForViewDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllQuestionsByMentor(response: HttpResponseBase): Observable<QuestionForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QuestionForViewDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuestionForViewDto[]>(<any>null);
    }

    getQuestionDetailForView(id: number | undefined): Observable<QuestionForViewDto> {
        let url_ = this.baseUrl + "/api/Question/GetQuestionDetailForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQuestionDetailForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuestionDetailForView(<any>response_);
                } catch (e) {
                    return <Observable<QuestionForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<QuestionForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetQuestionDetailForView(response: HttpResponseBase): Observable<QuestionForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuestionForViewDto>(<any>null);
    }

    getQuestionDetailForEdit(id: number | undefined): Observable<CreateOrEditQuestionDto> {
        let url_ = this.baseUrl + "/api/Question/GetQuestionDetailForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQuestionDetailForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuestionDetailForEdit(<any>response_);
                } catch (e) {
                    return <Observable<CreateOrEditQuestionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateOrEditQuestionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetQuestionDetailForEdit(response: HttpResponseBase): Observable<CreateOrEditQuestionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditQuestionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditQuestionDto>(<any>null);
    }

    getAllQuestionDetailForView(): Observable<QuestionViewDto[]> {
        let url_ = this.baseUrl + "/api/Question/GetAllQuestionDetailForView";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllQuestionDetailForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllQuestionDetailForView(<any>response_);
                } catch (e) {
                    return <Observable<QuestionViewDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<QuestionViewDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllQuestionDetailForView(response: HttpResponseBase): Observable<QuestionViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QuestionViewDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuestionViewDto[]>(<any>null);
    }
}

export interface IReligionServiceProxy {
    createOrUpdate(id: number | null | undefined, reliogionName: string | null | undefined): Observable<string>;
    deleteReligion(id: number | null | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class ReligionServiceProxy implements IReligionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    createOrUpdate(id: number | null | undefined, reliogionName: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Religion/CreateOrUpdate?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (reliogionName !== undefined)
            url_ += "reliogionName=" + encodeURIComponent("" + reliogionName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    deleteReligion(id: number | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Religion/DeleteReligion?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteReligion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteReligion(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteReligion(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

export interface ISMSServiceProxy {
    sendSMS(id: number | undefined): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class SMSServiceProxy implements ISMSServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    sendSMS(id: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/SMS/SendSMS?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendSMS(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendSMS(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processSendSMS(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

export interface ITodoItemsServiceProxy {
    create(command: CreateTodoItemCommand): Observable<number>;
    update(id: number, command: UpdateTodoItemCommand): Observable<FileResponse>;
    delete(id: number): Observable<FileResponse>;
    updateItemDetails(id: number | undefined, command: UpdateTodoItemDetailCommand): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class TodoItemsServiceProxy implements ITodoItemsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    create(command: CreateTodoItemCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/TodoItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    update(id: number, command: UpdateTodoItemCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/TodoItems/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }

    delete(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/TodoItems/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }

    updateItemDetails(id: number | undefined, command: UpdateTodoItemDetailCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/TodoItems/UpdateItemDetails?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateItemDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateItemDetails(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateItemDetails(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }
}

export interface ITodoListsServiceProxy {
    get(): Observable<TodosVm>;
    create(command: CreateTodoListCommand): Observable<number>;
    get2(id: number): Observable<FileResponse>;
    update(id: number, command: UpdateTodoListCommand): Observable<FileResponse>;
    delete(id: number): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class TodoListsServiceProxy implements ITodoListsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    get(): Observable<TodosVm> {
        let url_ = this.baseUrl + "/api/TodoLists";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<TodosVm>><any>_observableThrow(e);
                }
            } else
                return <Observable<TodosVm>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TodosVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TodosVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TodosVm>(<any>null);
    }

    create(command: CreateTodoListCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/TodoLists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    get2(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/TodoLists/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }

    update(id: number, command: UpdateTodoListCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/TodoLists/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }

    delete(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/TodoLists/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }
}

export interface IWeatherForecastServiceProxy {
    get(): Observable<WeatherForecast[]>;
}

@Injectable({
    providedIn: 'root'
})
export class WeatherForecastServiceProxy implements IWeatherForecastServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    get(): Observable<WeatherForecast[]> {
        let url_ = this.baseUrl + "/api/WeatherForecast";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<WeatherForecast[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<WeatherForecast[]>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<WeatherForecast[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WeatherForecast.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WeatherForecast[]>(<any>null);
    }
}

export class DropDownDto implements IDropDownDto {
    id?: number;
    name?: string | undefined;
    value?: string | undefined;

    constructor(data?: IDropDownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): DropDownDto {
        data = typeof data === 'object' ? data : {};
        let result = new DropDownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["value"] = this.value;
        return data; 
    }
}

export interface IDropDownDto {
    id?: number;
    name?: string | undefined;
    value?: string | undefined;
}

export class UpdateMenteeCommand implements IUpdateMenteeCommand {
    createOrUpdateMenteeDto?: CreateOrUpdateMenteeDto | undefined;

    constructor(data?: IUpdateMenteeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createOrUpdateMenteeDto = _data["createOrUpdateMenteeDto"] ? CreateOrUpdateMenteeDto.fromJS(_data["createOrUpdateMenteeDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateMenteeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMenteeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createOrUpdateMenteeDto"] = this.createOrUpdateMenteeDto ? this.createOrUpdateMenteeDto.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUpdateMenteeCommand {
    createOrUpdateMenteeDto?: CreateOrUpdateMenteeDto | undefined;
}

export class CreateOrUpdateMenteeDto implements ICreateOrUpdateMenteeDto {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    gender?: string | undefined;
    dob?: Date;
    address?: string | undefined;
    countryId?: number;
    cityId?: number;
    city?: string | undefined;
    userId?: string | undefined;
    email?: string | undefined;
    phoneNo?: string | undefined;

    constructor(data?: ICreateOrUpdateMenteeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.gender = _data["gender"];
            this.dob = _data["dob"] ? new Date(_data["dob"].toString()) : <any>undefined;
            this.address = _data["address"];
            this.countryId = _data["countryId"];
            this.cityId = _data["cityId"];
            this.city = _data["city"];
            this.userId = _data["userId"];
            this.email = _data["email"];
            this.phoneNo = _data["phoneNo"];
        }
    }

    static fromJS(data: any): CreateOrUpdateMenteeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateMenteeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["gender"] = this.gender;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>undefined;
        data["address"] = this.address;
        data["countryId"] = this.countryId;
        data["cityId"] = this.cityId;
        data["city"] = this.city;
        data["userId"] = this.userId;
        data["email"] = this.email;
        data["phoneNo"] = this.phoneNo;
        return data; 
    }
}

export interface ICreateOrUpdateMenteeDto {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    gender?: string | undefined;
    dob?: Date;
    address?: string | undefined;
    countryId?: number;
    cityId?: number;
    city?: string | undefined;
    userId?: string | undefined;
    email?: string | undefined;
    phoneNo?: string | undefined;
}

export class MenteesViewDto implements IMenteesViewDto {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    gender?: string | undefined;
    dob?: Date;
    address?: string | undefined;
    countryName?: string | undefined;
    city?: string | undefined;
    userId?: string | undefined;
    email?: string | undefined;
    phoneNo?: string | undefined;
    profileId?: string | undefined;
    profileDate?: string | undefined;
    menteeUserInfoDto?: MenteeUserInfo | undefined;

    constructor(data?: IMenteesViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.gender = _data["gender"];
            this.dob = _data["dob"] ? new Date(_data["dob"].toString()) : <any>undefined;
            this.address = _data["address"];
            this.countryName = _data["countryName"];
            this.city = _data["city"];
            this.userId = _data["userId"];
            this.email = _data["email"];
            this.phoneNo = _data["phoneNo"];
            this.profileId = _data["profileId"];
            this.profileDate = _data["profileDate"];
            this.menteeUserInfoDto = _data["menteeUserInfoDto"] ? MenteeUserInfo.fromJS(_data["menteeUserInfoDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MenteesViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new MenteesViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["gender"] = this.gender;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>undefined;
        data["address"] = this.address;
        data["countryName"] = this.countryName;
        data["city"] = this.city;
        data["userId"] = this.userId;
        data["email"] = this.email;
        data["phoneNo"] = this.phoneNo;
        data["profileId"] = this.profileId;
        data["profileDate"] = this.profileDate;
        data["menteeUserInfoDto"] = this.menteeUserInfoDto ? this.menteeUserInfoDto.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IMenteesViewDto {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    gender?: string | undefined;
    dob?: Date;
    address?: string | undefined;
    countryName?: string | undefined;
    city?: string | undefined;
    userId?: string | undefined;
    email?: string | undefined;
    phoneNo?: string | undefined;
    profileId?: string | undefined;
    profileDate?: string | undefined;
    menteeUserInfoDto?: MenteeUserInfo | undefined;
}

export class MenteeUserInfo implements IMenteeUserInfo {
    id?: string;
    concurrencyStamp?: string | undefined;
    lockoutEnd?: Date | undefined;
    twoFactorEnabled?: boolean;
    phoneNumberConfirmed?: boolean;
    phoneNumber?: string | undefined;
    securityStamp?: string | undefined;
    passwordHash?: string | undefined;
    emailConfirmed?: boolean;
    normalizedEmail?: string | undefined;
    email?: string | undefined;
    normalizedUserName?: string | undefined;
    userName?: string | undefined;

    constructor(data?: IMenteeUserInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            this.lockoutEnd = _data["lockoutEnd"] ? new Date(_data["lockoutEnd"].toString()) : <any>undefined;
            this.twoFactorEnabled = _data["twoFactorEnabled"];
            this.phoneNumberConfirmed = _data["phoneNumberConfirmed"];
            this.phoneNumber = _data["phoneNumber"];
            this.securityStamp = _data["securityStamp"];
            this.passwordHash = _data["passwordHash"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.normalizedEmail = _data["normalizedEmail"];
            this.email = _data["email"];
            this.normalizedUserName = _data["normalizedUserName"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): MenteeUserInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MenteeUserInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["concurrencyStamp"] = this.concurrencyStamp;
        data["lockoutEnd"] = this.lockoutEnd ? this.lockoutEnd.toISOString() : <any>undefined;
        data["twoFactorEnabled"] = this.twoFactorEnabled;
        data["phoneNumberConfirmed"] = this.phoneNumberConfirmed;
        data["phoneNumber"] = this.phoneNumber;
        data["securityStamp"] = this.securityStamp;
        data["passwordHash"] = this.passwordHash;
        data["emailConfirmed"] = this.emailConfirmed;
        data["normalizedEmail"] = this.normalizedEmail;
        data["email"] = this.email;
        data["normalizedUserName"] = this.normalizedUserName;
        data["userName"] = this.userName;
        return data; 
    }
}

export interface IMenteeUserInfo {
    id?: string;
    concurrencyStamp?: string | undefined;
    lockoutEnd?: Date | undefined;
    twoFactorEnabled?: boolean;
    phoneNumberConfirmed?: boolean;
    phoneNumber?: string | undefined;
    securityStamp?: string | undefined;
    passwordHash?: string | undefined;
    emailConfirmed?: boolean;
    normalizedEmail?: string | undefined;
    email?: string | undefined;
    normalizedUserName?: string | undefined;
    userName?: string | undefined;
}

export class UpdateMentorCommand implements IUpdateMentorCommand {
    createOrUpdateMentor?: CreateOrUpdateMentorDto | undefined;

    constructor(data?: IUpdateMentorCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createOrUpdateMentor = _data["createOrUpdateMentor"] ? CreateOrUpdateMentorDto.fromJS(_data["createOrUpdateMentor"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateMentorCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMentorCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createOrUpdateMentor"] = this.createOrUpdateMentor ? this.createOrUpdateMentor.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUpdateMentorCommand {
    createOrUpdateMentor?: CreateOrUpdateMentorDto | undefined;
}

export class CreateOrUpdateMentorDto implements ICreateOrUpdateMentorDto {
    id?: number;
    name?: string | undefined;
    fatherName?: string | undefined;
    gender?: string | undefined;
    religionId?: number;
    occupationId?: number;
    countryId?: number;
    cityId?: number;
    city?: string | undefined;
    dob?: Date;
    cnic?: string | undefined;
    passport?: string | undefined;
    address?: string | undefined;
    monthlyIncome?: number;
    chargesPerAnswer?: number;
    appointmentCharges?: number;
    availableTimingFrom?: string | undefined;
    availableTimingTo?: string | undefined;
    homeVisit?: boolean;
    homeVisitCharges?: number;
    bankAccountTitle?: string | undefined;
    bankAccountNo?: string | undefined;
    bankId?: number;
    cardNo?: string | undefined;
    cardType?: string | undefined;
    validTill?: Date;
    userId?: string;
    averageRating?: number;
    isProve?: boolean;
    mentorExperienceDtos?: MentorExperienceDto[] | undefined;
    mentorEducationDtos?: MentorEducationDto[] | undefined;
    mentorSkillSetDtos?: MentorSkillSetDto[] | undefined;

    constructor(data?: ICreateOrUpdateMentorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.fatherName = _data["fatherName"];
            this.gender = _data["gender"];
            this.religionId = _data["religionId"];
            this.occupationId = _data["occupationId"];
            this.countryId = _data["countryId"];
            this.cityId = _data["cityId"];
            this.city = _data["city"];
            this.dob = _data["dob"] ? new Date(_data["dob"].toString()) : <any>undefined;
            this.cnic = _data["cnic"];
            this.passport = _data["passport"];
            this.address = _data["address"];
            this.monthlyIncome = _data["monthlyIncome"];
            this.chargesPerAnswer = _data["chargesPerAnswer"];
            this.appointmentCharges = _data["appointmentCharges"];
            this.availableTimingFrom = _data["availableTimingFrom"];
            this.availableTimingTo = _data["availableTimingTo"];
            this.homeVisit = _data["homeVisit"];
            this.homeVisitCharges = _data["homeVisitCharges"];
            this.bankAccountTitle = _data["bankAccountTitle"];
            this.bankAccountNo = _data["bankAccountNo"];
            this.bankId = _data["bankId"];
            this.cardNo = _data["cardNo"];
            this.cardType = _data["cardType"];
            this.validTill = _data["validTill"] ? new Date(_data["validTill"].toString()) : <any>undefined;
            this.userId = _data["userId"];
            this.averageRating = _data["averageRating"];
            this.isProve = _data["isProve"];
            if (Array.isArray(_data["mentorExperienceDtos"])) {
                this.mentorExperienceDtos = [] as any;
                for (let item of _data["mentorExperienceDtos"])
                    this.mentorExperienceDtos!.push(MentorExperienceDto.fromJS(item));
            }
            if (Array.isArray(_data["mentorEducationDtos"])) {
                this.mentorEducationDtos = [] as any;
                for (let item of _data["mentorEducationDtos"])
                    this.mentorEducationDtos!.push(MentorEducationDto.fromJS(item));
            }
            if (Array.isArray(_data["mentorSkillSetDtos"])) {
                this.mentorSkillSetDtos = [] as any;
                for (let item of _data["mentorSkillSetDtos"])
                    this.mentorSkillSetDtos!.push(MentorSkillSetDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateMentorDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateMentorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["fatherName"] = this.fatherName;
        data["gender"] = this.gender;
        data["religionId"] = this.religionId;
        data["occupationId"] = this.occupationId;
        data["countryId"] = this.countryId;
        data["cityId"] = this.cityId;
        data["city"] = this.city;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>undefined;
        data["cnic"] = this.cnic;
        data["passport"] = this.passport;
        data["address"] = this.address;
        data["monthlyIncome"] = this.monthlyIncome;
        data["chargesPerAnswer"] = this.chargesPerAnswer;
        data["appointmentCharges"] = this.appointmentCharges;
        data["availableTimingFrom"] = this.availableTimingFrom;
        data["availableTimingTo"] = this.availableTimingTo;
        data["homeVisit"] = this.homeVisit;
        data["homeVisitCharges"] = this.homeVisitCharges;
        data["bankAccountTitle"] = this.bankAccountTitle;
        data["bankAccountNo"] = this.bankAccountNo;
        data["bankId"] = this.bankId;
        data["cardNo"] = this.cardNo;
        data["cardType"] = this.cardType;
        data["validTill"] = this.validTill ? this.validTill.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["averageRating"] = this.averageRating;
        data["isProve"] = this.isProve;
        if (Array.isArray(this.mentorExperienceDtos)) {
            data["mentorExperienceDtos"] = [];
            for (let item of this.mentorExperienceDtos)
                data["mentorExperienceDtos"].push(item.toJSON());
        }
        if (Array.isArray(this.mentorEducationDtos)) {
            data["mentorEducationDtos"] = [];
            for (let item of this.mentorEducationDtos)
                data["mentorEducationDtos"].push(item.toJSON());
        }
        if (Array.isArray(this.mentorSkillSetDtos)) {
            data["mentorSkillSetDtos"] = [];
            for (let item of this.mentorSkillSetDtos)
                data["mentorSkillSetDtos"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateOrUpdateMentorDto {
    id?: number;
    name?: string | undefined;
    fatherName?: string | undefined;
    gender?: string | undefined;
    religionId?: number;
    occupationId?: number;
    countryId?: number;
    cityId?: number;
    city?: string | undefined;
    dob?: Date;
    cnic?: string | undefined;
    passport?: string | undefined;
    address?: string | undefined;
    monthlyIncome?: number;
    chargesPerAnswer?: number;
    appointmentCharges?: number;
    availableTimingFrom?: string | undefined;
    availableTimingTo?: string | undefined;
    homeVisit?: boolean;
    homeVisitCharges?: number;
    bankAccountTitle?: string | undefined;
    bankAccountNo?: string | undefined;
    bankId?: number;
    cardNo?: string | undefined;
    cardType?: string | undefined;
    validTill?: Date;
    userId?: string;
    averageRating?: number;
    isProve?: boolean;
    mentorExperienceDtos?: MentorExperienceDto[] | undefined;
    mentorEducationDtos?: MentorEducationDto[] | undefined;
    mentorSkillSetDtos?: MentorSkillSetDto[] | undefined;
}

export class MentorExperienceDto implements IMentorExperienceDto {
    id?: number;
    companyName?: string | undefined;
    workFrom?: Date;
    workTo?: Date;
    isCurrentlyWorking?: boolean;
    experienceCertificateId?: string | undefined;
    certificateDescription?: string | undefined;

    constructor(data?: IMentorExperienceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyName = _data["companyName"];
            this.workFrom = _data["workFrom"] ? new Date(_data["workFrom"].toString()) : <any>undefined;
            this.workTo = _data["workTo"] ? new Date(_data["workTo"].toString()) : <any>undefined;
            this.isCurrentlyWorking = _data["isCurrentlyWorking"];
            this.experienceCertificateId = _data["experienceCertificateId"];
            this.certificateDescription = _data["certificateDescription"];
        }
    }

    static fromJS(data: any): MentorExperienceDto {
        data = typeof data === 'object' ? data : {};
        let result = new MentorExperienceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyName"] = this.companyName;
        data["workFrom"] = this.workFrom ? this.workFrom.toISOString() : <any>undefined;
        data["workTo"] = this.workTo ? this.workTo.toISOString() : <any>undefined;
        data["isCurrentlyWorking"] = this.isCurrentlyWorking;
        data["experienceCertificateId"] = this.experienceCertificateId;
        data["certificateDescription"] = this.certificateDescription;
        return data; 
    }
}

export interface IMentorExperienceDto {
    id?: number;
    companyName?: string | undefined;
    workFrom?: Date;
    workTo?: Date;
    isCurrentlyWorking?: boolean;
    experienceCertificateId?: string | undefined;
    certificateDescription?: string | undefined;
}

export class MentorEducationDto implements IMentorEducationDto {
    id?: number;
    degreeId?: number;
    yearCompleted?: number;
    degreeName?: string | undefined;
    subject?: string | undefined;
    institute?: string | undefined;

    constructor(data?: IMentorEducationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.degreeId = _data["degreeId"];
            this.yearCompleted = _data["yearCompleted"];
            this.degreeName = _data["degreeName"];
            this.subject = _data["subject"];
            this.institute = _data["institute"];
        }
    }

    static fromJS(data: any): MentorEducationDto {
        data = typeof data === 'object' ? data : {};
        let result = new MentorEducationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["degreeId"] = this.degreeId;
        data["yearCompleted"] = this.yearCompleted;
        data["degreeName"] = this.degreeName;
        data["subject"] = this.subject;
        data["institute"] = this.institute;
        return data; 
    }
}

export interface IMentorEducationDto {
    id?: number;
    degreeId?: number;
    yearCompleted?: number;
    degreeName?: string | undefined;
    subject?: string | undefined;
    institute?: string | undefined;
}

export class MentorSkillSetDto implements IMentorSkillSetDto {
    id?: number;
    mentorId?: number;
    departmentId?: number;
    departmentName?: string | undefined;
    categoryId?: number;
    categoryName?: string | undefined;
    subCategoryId?: number;
    subCategoryName?: string | undefined;

    constructor(data?: IMentorSkillSetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mentorId = _data["mentorId"];
            this.departmentId = _data["departmentId"];
            this.departmentName = _data["departmentName"];
            this.categoryId = _data["categoryId"];
            this.categoryName = _data["categoryName"];
            this.subCategoryId = _data["subCategoryId"];
            this.subCategoryName = _data["subCategoryName"];
        }
    }

    static fromJS(data: any): MentorSkillSetDto {
        data = typeof data === 'object' ? data : {};
        let result = new MentorSkillSetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mentorId"] = this.mentorId;
        data["departmentId"] = this.departmentId;
        data["departmentName"] = this.departmentName;
        data["categoryId"] = this.categoryId;
        data["categoryName"] = this.categoryName;
        data["subCategoryId"] = this.subCategoryId;
        data["subCategoryName"] = this.subCategoryName;
        return data; 
    }
}

export interface IMentorSkillSetDto {
    id?: number;
    mentorId?: number;
    departmentId?: number;
    departmentName?: string | undefined;
    categoryId?: number;
    categoryName?: string | undefined;
    subCategoryId?: number;
    subCategoryName?: string | undefined;
}

export class MentorDto implements IMentorDto {
    id?: number;
    name?: string | undefined;
    fatherName?: string | undefined;
    fullName?: string | undefined;
    gender?: string | undefined;
    religion?: string | undefined;
    profession?: string | undefined;
    countryName?: string | undefined;
    city?: string | undefined;
    age?: number;
    address?: string | undefined;
    chargesPerAnswer?: number;
    appointmentCharges?: number;
    availableTimingFrom?: string | undefined;
    availableTimingTo?: string | undefined;
    homeVisit?: boolean;
    homeVisitCharges?: number;
    averageRating?: number;
    userId?: string | undefined;
    isProfileCompleted?: boolean;
    profileCompletePercentage?: number;
    isProve?: boolean;
    userInfoDto?: MentorUserInfo | undefined;
    mentorExperienceDtos?: MentorExperienceDto[] | undefined;
    mentorEducationDtos?: MentorEducationDto[] | undefined;
    mentorSkillSetDtos?: MentorSkillSetDto[] | undefined;

    constructor(data?: IMentorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.fatherName = _data["fatherName"];
            this.fullName = _data["fullName"];
            this.gender = _data["gender"];
            this.religion = _data["religion"];
            this.profession = _data["profession"];
            this.countryName = _data["countryName"];
            this.city = _data["city"];
            this.age = _data["age"];
            this.address = _data["address"];
            this.chargesPerAnswer = _data["chargesPerAnswer"];
            this.appointmentCharges = _data["appointmentCharges"];
            this.availableTimingFrom = _data["availableTimingFrom"];
            this.availableTimingTo = _data["availableTimingTo"];
            this.homeVisit = _data["homeVisit"];
            this.homeVisitCharges = _data["homeVisitCharges"];
            this.averageRating = _data["averageRating"];
            this.userId = _data["userId"];
            this.isProfileCompleted = _data["isProfileCompleted"];
            this.profileCompletePercentage = _data["profileCompletePercentage"];
            this.isProve = _data["isProve"];
            this.userInfoDto = _data["userInfoDto"] ? MentorUserInfo.fromJS(_data["userInfoDto"]) : <any>undefined;
            if (Array.isArray(_data["mentorExperienceDtos"])) {
                this.mentorExperienceDtos = [] as any;
                for (let item of _data["mentorExperienceDtos"])
                    this.mentorExperienceDtos!.push(MentorExperienceDto.fromJS(item));
            }
            if (Array.isArray(_data["mentorEducationDtos"])) {
                this.mentorEducationDtos = [] as any;
                for (let item of _data["mentorEducationDtos"])
                    this.mentorEducationDtos!.push(MentorEducationDto.fromJS(item));
            }
            if (Array.isArray(_data["mentorSkillSetDtos"])) {
                this.mentorSkillSetDtos = [] as any;
                for (let item of _data["mentorSkillSetDtos"])
                    this.mentorSkillSetDtos!.push(MentorSkillSetDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MentorDto {
        data = typeof data === 'object' ? data : {};
        let result = new MentorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["fatherName"] = this.fatherName;
        data["fullName"] = this.fullName;
        data["gender"] = this.gender;
        data["religion"] = this.religion;
        data["profession"] = this.profession;
        data["countryName"] = this.countryName;
        data["city"] = this.city;
        data["age"] = this.age;
        data["address"] = this.address;
        data["chargesPerAnswer"] = this.chargesPerAnswer;
        data["appointmentCharges"] = this.appointmentCharges;
        data["availableTimingFrom"] = this.availableTimingFrom;
        data["availableTimingTo"] = this.availableTimingTo;
        data["homeVisit"] = this.homeVisit;
        data["homeVisitCharges"] = this.homeVisitCharges;
        data["averageRating"] = this.averageRating;
        data["userId"] = this.userId;
        data["isProfileCompleted"] = this.isProfileCompleted;
        data["profileCompletePercentage"] = this.profileCompletePercentage;
        data["isProve"] = this.isProve;
        data["userInfoDto"] = this.userInfoDto ? this.userInfoDto.toJSON() : <any>undefined;
        if (Array.isArray(this.mentorExperienceDtos)) {
            data["mentorExperienceDtos"] = [];
            for (let item of this.mentorExperienceDtos)
                data["mentorExperienceDtos"].push(item.toJSON());
        }
        if (Array.isArray(this.mentorEducationDtos)) {
            data["mentorEducationDtos"] = [];
            for (let item of this.mentorEducationDtos)
                data["mentorEducationDtos"].push(item.toJSON());
        }
        if (Array.isArray(this.mentorSkillSetDtos)) {
            data["mentorSkillSetDtos"] = [];
            for (let item of this.mentorSkillSetDtos)
                data["mentorSkillSetDtos"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IMentorDto {
    id?: number;
    name?: string | undefined;
    fatherName?: string | undefined;
    fullName?: string | undefined;
    gender?: string | undefined;
    religion?: string | undefined;
    profession?: string | undefined;
    countryName?: string | undefined;
    city?: string | undefined;
    age?: number;
    address?: string | undefined;
    chargesPerAnswer?: number;
    appointmentCharges?: number;
    availableTimingFrom?: string | undefined;
    availableTimingTo?: string | undefined;
    homeVisit?: boolean;
    homeVisitCharges?: number;
    averageRating?: number;
    userId?: string | undefined;
    isProfileCompleted?: boolean;
    profileCompletePercentage?: number;
    isProve?: boolean;
    userInfoDto?: MentorUserInfo | undefined;
    mentorExperienceDtos?: MentorExperienceDto[] | undefined;
    mentorEducationDtos?: MentorEducationDto[] | undefined;
    mentorSkillSetDtos?: MentorSkillSetDto[] | undefined;
}

export class MentorUserInfo implements IMentorUserInfo {
    id?: string;
    concurrencyStamp?: string | undefined;
    lockoutEnd?: Date | undefined;
    twoFactorEnabled?: boolean;
    phoneNumberConfirmed?: boolean;
    phoneNumber?: string | undefined;
    securityStamp?: string | undefined;
    passwordHash?: string | undefined;
    emailConfirmed?: boolean;
    normalizedEmail?: string | undefined;
    email?: string | undefined;
    normalizedUserName?: string | undefined;
    userName?: string | undefined;

    constructor(data?: IMentorUserInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            this.lockoutEnd = _data["lockoutEnd"] ? new Date(_data["lockoutEnd"].toString()) : <any>undefined;
            this.twoFactorEnabled = _data["twoFactorEnabled"];
            this.phoneNumberConfirmed = _data["phoneNumberConfirmed"];
            this.phoneNumber = _data["phoneNumber"];
            this.securityStamp = _data["securityStamp"];
            this.passwordHash = _data["passwordHash"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.normalizedEmail = _data["normalizedEmail"];
            this.email = _data["email"];
            this.normalizedUserName = _data["normalizedUserName"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): MentorUserInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MentorUserInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["concurrencyStamp"] = this.concurrencyStamp;
        data["lockoutEnd"] = this.lockoutEnd ? this.lockoutEnd.toISOString() : <any>undefined;
        data["twoFactorEnabled"] = this.twoFactorEnabled;
        data["phoneNumberConfirmed"] = this.phoneNumberConfirmed;
        data["phoneNumber"] = this.phoneNumber;
        data["securityStamp"] = this.securityStamp;
        data["passwordHash"] = this.passwordHash;
        data["emailConfirmed"] = this.emailConfirmed;
        data["normalizedEmail"] = this.normalizedEmail;
        data["email"] = this.email;
        data["normalizedUserName"] = this.normalizedUserName;
        data["userName"] = this.userName;
        return data; 
    }
}

export interface IMentorUserInfo {
    id?: string;
    concurrencyStamp?: string | undefined;
    lockoutEnd?: Date | undefined;
    twoFactorEnabled?: boolean;
    phoneNumberConfirmed?: boolean;
    phoneNumber?: string | undefined;
    securityStamp?: string | undefined;
    passwordHash?: string | undefined;
    emailConfirmed?: boolean;
    normalizedEmail?: string | undefined;
    email?: string | undefined;
    normalizedUserName?: string | undefined;
    userName?: string | undefined;
}

export class MentorViewDto implements IMentorViewDto {
    id?: number;
    name?: string | undefined;
    fatherName?: string | undefined;
    fullName?: string | undefined;
    gender?: string | undefined;
    religion?: string | undefined;
    profession?: string | undefined;
    countryName?: string | undefined;
    city?: string | undefined;
    age?: number;
    address?: string | undefined;
    chargesPerAnswer?: number;
    appointmentCharges?: number;
    availableTimingFrom?: string | undefined;
    availableTimingTo?: string | undefined;
    homeVisit?: boolean;
    homeVisitCharges?: number;
    averageRating?: number;
    userId?: string | undefined;
    isProfileCompleted?: boolean;
    profilePictureID?: string | undefined;
    profilePicture?: string | undefined;
    createdDate?: Date | undefined;
    isProve?: boolean;
    mentorExperienceDtos?: MentorExperienceDto[] | undefined;
    mentorEducationDtos?: MentorEducationDto[] | undefined;
    mentorSkillSetDtos?: MentorSkillSetDto[] | undefined;

    constructor(data?: IMentorViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.fatherName = _data["fatherName"];
            this.fullName = _data["fullName"];
            this.gender = _data["gender"];
            this.religion = _data["religion"];
            this.profession = _data["profession"];
            this.countryName = _data["countryName"];
            this.city = _data["city"];
            this.age = _data["age"];
            this.address = _data["address"];
            this.chargesPerAnswer = _data["chargesPerAnswer"];
            this.appointmentCharges = _data["appointmentCharges"];
            this.availableTimingFrom = _data["availableTimingFrom"];
            this.availableTimingTo = _data["availableTimingTo"];
            this.homeVisit = _data["homeVisit"];
            this.homeVisitCharges = _data["homeVisitCharges"];
            this.averageRating = _data["averageRating"];
            this.userId = _data["userId"];
            this.isProfileCompleted = _data["isProfileCompleted"];
            this.profilePictureID = _data["profilePictureID"];
            this.profilePicture = _data["profilePicture"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.isProve = _data["isProve"];
            if (Array.isArray(_data["mentorExperienceDtos"])) {
                this.mentorExperienceDtos = [] as any;
                for (let item of _data["mentorExperienceDtos"])
                    this.mentorExperienceDtos!.push(MentorExperienceDto.fromJS(item));
            }
            if (Array.isArray(_data["mentorEducationDtos"])) {
                this.mentorEducationDtos = [] as any;
                for (let item of _data["mentorEducationDtos"])
                    this.mentorEducationDtos!.push(MentorEducationDto.fromJS(item));
            }
            if (Array.isArray(_data["mentorSkillSetDtos"])) {
                this.mentorSkillSetDtos = [] as any;
                for (let item of _data["mentorSkillSetDtos"])
                    this.mentorSkillSetDtos!.push(MentorSkillSetDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MentorViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new MentorViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["fatherName"] = this.fatherName;
        data["fullName"] = this.fullName;
        data["gender"] = this.gender;
        data["religion"] = this.religion;
        data["profession"] = this.profession;
        data["countryName"] = this.countryName;
        data["city"] = this.city;
        data["age"] = this.age;
        data["address"] = this.address;
        data["chargesPerAnswer"] = this.chargesPerAnswer;
        data["appointmentCharges"] = this.appointmentCharges;
        data["availableTimingFrom"] = this.availableTimingFrom;
        data["availableTimingTo"] = this.availableTimingTo;
        data["homeVisit"] = this.homeVisit;
        data["homeVisitCharges"] = this.homeVisitCharges;
        data["averageRating"] = this.averageRating;
        data["userId"] = this.userId;
        data["isProfileCompleted"] = this.isProfileCompleted;
        data["profilePictureID"] = this.profilePictureID;
        data["profilePicture"] = this.profilePicture;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["isProve"] = this.isProve;
        if (Array.isArray(this.mentorExperienceDtos)) {
            data["mentorExperienceDtos"] = [];
            for (let item of this.mentorExperienceDtos)
                data["mentorExperienceDtos"].push(item.toJSON());
        }
        if (Array.isArray(this.mentorEducationDtos)) {
            data["mentorEducationDtos"] = [];
            for (let item of this.mentorEducationDtos)
                data["mentorEducationDtos"].push(item.toJSON());
        }
        if (Array.isArray(this.mentorSkillSetDtos)) {
            data["mentorSkillSetDtos"] = [];
            for (let item of this.mentorSkillSetDtos)
                data["mentorSkillSetDtos"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IMentorViewDto {
    id?: number;
    name?: string | undefined;
    fatherName?: string | undefined;
    fullName?: string | undefined;
    gender?: string | undefined;
    religion?: string | undefined;
    profession?: string | undefined;
    countryName?: string | undefined;
    city?: string | undefined;
    age?: number;
    address?: string | undefined;
    chargesPerAnswer?: number;
    appointmentCharges?: number;
    availableTimingFrom?: string | undefined;
    availableTimingTo?: string | undefined;
    homeVisit?: boolean;
    homeVisitCharges?: number;
    averageRating?: number;
    userId?: string | undefined;
    isProfileCompleted?: boolean;
    profilePictureID?: string | undefined;
    profilePicture?: string | undefined;
    createdDate?: Date | undefined;
    isProve?: boolean;
    mentorExperienceDtos?: MentorExperienceDto[] | undefined;
    mentorEducationDtos?: MentorEducationDto[] | undefined;
    mentorSkillSetDtos?: MentorSkillSetDto[] | undefined;
}

export class MentorCharageDto implements IMentorCharageDto {
    id?: number;
    appointmentCharges?: number;

    constructor(data?: IMentorCharageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.appointmentCharges = _data["appointmentCharges"];
        }
    }

    static fromJS(data: any): MentorCharageDto {
        data = typeof data === 'object' ? data : {};
        let result = new MentorCharageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["appointmentCharges"] = this.appointmentCharges;
        return data; 
    }
}

export interface IMentorCharageDto {
    id?: number;
    appointmentCharges?: number;
}

export class LoginResponse implements ILoginResponse {
    email?: string | undefined;
    userName?: string | undefined;
    phoneNumber?: string | undefined;
    role?: string | undefined;
    data?: string | undefined;
    token?: string | undefined;
    isSuccess?: boolean;
    userId?: string | undefined;
    autoUserId?: number;
    profilePictureId?: string | undefined;
    errors?: string[] | undefined;

    constructor(data?: ILoginResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.userName = _data["userName"];
            this.phoneNumber = _data["phoneNumber"];
            this.role = _data["role"];
            this.data = _data["data"];
            this.token = _data["token"];
            this.isSuccess = _data["isSuccess"];
            this.userId = _data["userId"];
            this.autoUserId = _data["autoUserId"];
            this.profilePictureId = _data["profilePictureId"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): LoginResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LoginResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["userName"] = this.userName;
        data["phoneNumber"] = this.phoneNumber;
        data["role"] = this.role;
        data["data"] = this.data;
        data["token"] = this.token;
        data["isSuccess"] = this.isSuccess;
        data["userId"] = this.userId;
        data["autoUserId"] = this.autoUserId;
        data["profilePictureId"] = this.profilePictureId;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }
}

export interface ILoginResponse {
    email?: string | undefined;
    userName?: string | undefined;
    phoneNumber?: string | undefined;
    role?: string | undefined;
    data?: string | undefined;
    token?: string | undefined;
    isSuccess?: boolean;
    userId?: string | undefined;
    autoUserId?: number;
    profilePictureId?: string | undefined;
    errors?: string[] | undefined;
}

export class LoginQuery implements ILoginQuery {
    email?: string | undefined;
    password?: string | undefined;

    constructor(data?: ILoginQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LoginQuery {
        data = typeof data === 'object' ? data : {};
        let result = new LoginQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        return data; 
    }
}

export interface ILoginQuery {
    email?: string | undefined;
    password?: string | undefined;
}

export class SignUpResponse implements ISignUpResponse {
    data?: string | undefined;

    constructor(data?: ISignUpResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): SignUpResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SignUpResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        return data; 
    }
}

export interface ISignUpResponse {
    data?: string | undefined;
}

export class SignUpCommand implements ISignUpCommand {
    userName?: string | undefined;
    roleName?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
    phoneNumberConfirmed?: boolean;
    confirmPassword?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    provider?: string | undefined;
    photoUrl?: string | undefined;

    constructor(data?: ISignUpCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.roleName = _data["roleName"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.password = _data["password"];
            this.phoneNumberConfirmed = _data["phoneNumberConfirmed"];
            this.confirmPassword = _data["confirmPassword"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.provider = _data["provider"];
            this.photoUrl = _data["photoUrl"];
        }
    }

    static fromJS(data: any): SignUpCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SignUpCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["roleName"] = this.roleName;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["password"] = this.password;
        data["phoneNumberConfirmed"] = this.phoneNumberConfirmed;
        data["confirmPassword"] = this.confirmPassword;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["provider"] = this.provider;
        data["photoUrl"] = this.photoUrl;
        return data; 
    }
}

export interface ISignUpCommand {
    userName?: string | undefined;
    roleName?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
    phoneNumberConfirmed?: boolean;
    confirmPassword?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    provider?: string | undefined;
    photoUrl?: string | undefined;
}

export class SignUpWithLoginCommand implements ISignUpWithLoginCommand {
    userName?: string | undefined;
    roleName?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    provider?: string | undefined;
    photoUrl?: string | undefined;

    constructor(data?: ISignUpWithLoginCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.roleName = _data["roleName"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.password = _data["password"];
            this.confirmPassword = _data["confirmPassword"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.provider = _data["provider"];
            this.photoUrl = _data["photoUrl"];
        }
    }

    static fromJS(data: any): SignUpWithLoginCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SignUpWithLoginCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["roleName"] = this.roleName;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["provider"] = this.provider;
        data["photoUrl"] = this.photoUrl;
        return data; 
    }
}

export interface ISignUpWithLoginCommand {
    userName?: string | undefined;
    roleName?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    provider?: string | undefined;
    photoUrl?: string | undefined;
}

export class LogoutQuery implements ILogoutQuery {
    number?: number;

    constructor(data?: ILogoutQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
        }
    }

    static fromJS(data: any): LogoutQuery {
        data = typeof data === 'object' ? data : {};
        let result = new LogoutQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        return data; 
    }
}

export interface ILogoutQuery {
    number?: number;
}

export class GetProfilePictureOutput implements IGetProfilePictureOutput {
    profilePicture?: string | undefined;

    constructor(data?: IGetProfilePictureOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profilePicture = _data["profilePicture"];
        }
    }

    static fromJS(data: any): GetProfilePictureOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProfilePictureOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePicture"] = this.profilePicture;
        return data; 
    }
}

export interface IGetProfilePictureOutput {
    profilePicture?: string | undefined;
}

export class Result implements IResult {
    succeeded?: boolean;
    errors?: string[] | undefined;

    constructor(data?: IResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): Result {
        data = typeof data === 'object' ? data : {};
        let result = new Result();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }
}

export interface IResult {
    succeeded?: boolean;
    errors?: string[] | undefined;
}

export class AppointmentDto implements IAppointmentDto {
    id?: number;
    mentorId?: number;
    menteeId?: number;
    mentorName?: string | undefined;
    menteeName?: string | undefined;
    mentorUserId?: string | undefined;
    menteeUserId?: string | undefined;
    profession?: string | undefined;
    appointmentDate?: Date;
    appointmentTime?: string | undefined;
    timeAgo?: string | undefined;
    questionId?: number;
    status?: string | undefined;
    charges?: number;
    isPaid?: boolean;
    mentorProfileUrl?: string | undefined;
    menteeProfileUrl?: string | undefined;

    constructor(data?: IAppointmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mentorId = _data["mentorId"];
            this.menteeId = _data["menteeId"];
            this.mentorName = _data["mentorName"];
            this.menteeName = _data["menteeName"];
            this.mentorUserId = _data["mentorUserId"];
            this.menteeUserId = _data["menteeUserId"];
            this.profession = _data["profession"];
            this.appointmentDate = _data["appointmentDate"] ? new Date(_data["appointmentDate"].toString()) : <any>undefined;
            this.appointmentTime = _data["appointmentTime"];
            this.timeAgo = _data["timeAgo"];
            this.questionId = _data["questionId"];
            this.status = _data["status"];
            this.charges = _data["charges"];
            this.isPaid = _data["isPaid"];
            this.mentorProfileUrl = _data["mentorProfileUrl"];
            this.menteeProfileUrl = _data["menteeProfileUrl"];
        }
    }

    static fromJS(data: any): AppointmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mentorId"] = this.mentorId;
        data["menteeId"] = this.menteeId;
        data["mentorName"] = this.mentorName;
        data["menteeName"] = this.menteeName;
        data["mentorUserId"] = this.mentorUserId;
        data["menteeUserId"] = this.menteeUserId;
        data["profession"] = this.profession;
        data["appointmentDate"] = this.appointmentDate ? this.appointmentDate.toISOString() : <any>undefined;
        data["appointmentTime"] = this.appointmentTime;
        data["timeAgo"] = this.timeAgo;
        data["questionId"] = this.questionId;
        data["status"] = this.status;
        data["charges"] = this.charges;
        data["isPaid"] = this.isPaid;
        data["mentorProfileUrl"] = this.mentorProfileUrl;
        data["menteeProfileUrl"] = this.menteeProfileUrl;
        return data; 
    }
}

export interface IAppointmentDto {
    id?: number;
    mentorId?: number;
    menteeId?: number;
    mentorName?: string | undefined;
    menteeName?: string | undefined;
    mentorUserId?: string | undefined;
    menteeUserId?: string | undefined;
    profession?: string | undefined;
    appointmentDate?: Date;
    appointmentTime?: string | undefined;
    timeAgo?: string | undefined;
    questionId?: number;
    status?: string | undefined;
    charges?: number;
    isPaid?: boolean;
    mentorProfileUrl?: string | undefined;
    menteeProfileUrl?: string | undefined;
}

export class AdminDashboardDto implements IAdminDashboardDto {
    totalMentor?: number;
    totalMentee?: number;
    totalQuestion?: number;
    totalOpenQuestion?: number;
    totalClosedQuestion?: number;
    totalAppointement?: number;
    totalCompleteAppointement?: number;
    totalUpCoimngAppointement?: number;

    constructor(data?: IAdminDashboardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalMentor = _data["totalMentor"];
            this.totalMentee = _data["totalMentee"];
            this.totalQuestion = _data["totalQuestion"];
            this.totalOpenQuestion = _data["totalOpenQuestion"];
            this.totalClosedQuestion = _data["totalClosedQuestion"];
            this.totalAppointement = _data["totalAppointement"];
            this.totalCompleteAppointement = _data["totalCompleteAppointement"];
            this.totalUpCoimngAppointement = _data["totalUpCoimngAppointement"];
        }
    }

    static fromJS(data: any): AdminDashboardDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminDashboardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalMentor"] = this.totalMentor;
        data["totalMentee"] = this.totalMentee;
        data["totalQuestion"] = this.totalQuestion;
        data["totalOpenQuestion"] = this.totalOpenQuestion;
        data["totalClosedQuestion"] = this.totalClosedQuestion;
        data["totalAppointement"] = this.totalAppointement;
        data["totalCompleteAppointement"] = this.totalCompleteAppointement;
        data["totalUpCoimngAppointement"] = this.totalUpCoimngAppointement;
        return data; 
    }
}

export interface IAdminDashboardDto {
    totalMentor?: number;
    totalMentee?: number;
    totalQuestion?: number;
    totalOpenQuestion?: number;
    totalClosedQuestion?: number;
    totalAppointement?: number;
    totalCompleteAppointement?: number;
    totalUpCoimngAppointement?: number;
}

export class CreatePaymentDto implements ICreatePaymentDto {
    paymentTo?: number;
    paymentBy?: number;
    questionId?: number;
    amount?: number;
    description?: string | undefined;
    cardNumber?: string | undefined;
    cardExpiry?: string | undefined;
    cardCvv?: number;
    paymentType?: number;
    subscriptionPaymentGatewayType?: SubscriptionPaymentGatewayType;
    invoiceNo?: string | undefined;
    mobileNumber?: string | undefined;
    cnic?: string | undefined;
    successUrl?: string | undefined;
    errorUrl?: string | undefined;

    constructor(data?: ICreatePaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentTo = _data["paymentTo"];
            this.paymentBy = _data["paymentBy"];
            this.questionId = _data["questionId"];
            this.amount = _data["amount"];
            this.description = _data["description"];
            this.cardNumber = _data["cardNumber"];
            this.cardExpiry = _data["cardExpiry"];
            this.cardCvv = _data["cardCvv"];
            this.paymentType = _data["paymentType"];
            this.subscriptionPaymentGatewayType = _data["subscriptionPaymentGatewayType"];
            this.invoiceNo = _data["invoiceNo"];
            this.mobileNumber = _data["mobileNumber"];
            this.cnic = _data["cnic"];
            this.successUrl = _data["successUrl"];
            this.errorUrl = _data["errorUrl"];
        }
    }

    static fromJS(data: any): CreatePaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentTo"] = this.paymentTo;
        data["paymentBy"] = this.paymentBy;
        data["questionId"] = this.questionId;
        data["amount"] = this.amount;
        data["description"] = this.description;
        data["cardNumber"] = this.cardNumber;
        data["cardExpiry"] = this.cardExpiry;
        data["cardCvv"] = this.cardCvv;
        data["paymentType"] = this.paymentType;
        data["subscriptionPaymentGatewayType"] = this.subscriptionPaymentGatewayType;
        data["invoiceNo"] = this.invoiceNo;
        data["mobileNumber"] = this.mobileNumber;
        data["cnic"] = this.cnic;
        data["successUrl"] = this.successUrl;
        data["errorUrl"] = this.errorUrl;
        return data; 
    }
}

export interface ICreatePaymentDto {
    paymentTo?: number;
    paymentBy?: number;
    questionId?: number;
    amount?: number;
    description?: string | undefined;
    cardNumber?: string | undefined;
    cardExpiry?: string | undefined;
    cardCvv?: number;
    paymentType?: number;
    subscriptionPaymentGatewayType?: SubscriptionPaymentGatewayType;
    invoiceNo?: string | undefined;
    mobileNumber?: string | undefined;
    cnic?: string | undefined;
    successUrl?: string | undefined;
    errorUrl?: string | undefined;
}

export enum SubscriptionPaymentGatewayType {
    EasyPaisa = 1,
    JazzCash = 2,
    HBL = 3,
    Paypal = 4,
    Stripe = 5,
    JazzCashMobileAccount = 6,
}

export class CreateOrEditAppointmentDto implements ICreateOrEditAppointmentDto {
    mentorId?: number;
    menteeId?: number;
    appointmentDate?: Date;
    appointmentTime?: string | undefined;
    questionId?: number;
    status?: string | undefined;
    charges?: number;

    constructor(data?: ICreateOrEditAppointmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mentorId = _data["mentorId"];
            this.menteeId = _data["menteeId"];
            this.appointmentDate = _data["appointmentDate"] ? new Date(_data["appointmentDate"].toString()) : <any>undefined;
            this.appointmentTime = _data["appointmentTime"];
            this.questionId = _data["questionId"];
            this.status = _data["status"];
            this.charges = _data["charges"];
        }
    }

    static fromJS(data: any): CreateOrEditAppointmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditAppointmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mentorId"] = this.mentorId;
        data["menteeId"] = this.menteeId;
        data["appointmentDate"] = this.appointmentDate ? this.appointmentDate.toISOString() : <any>undefined;
        data["appointmentTime"] = this.appointmentTime;
        data["questionId"] = this.questionId;
        data["status"] = this.status;
        data["charges"] = this.charges;
        return data; 
    }
}

export interface ICreateOrEditAppointmentDto {
    mentorId?: number;
    menteeId?: number;
    appointmentDate?: Date;
    appointmentTime?: string | undefined;
    questionId?: number;
    status?: string | undefined;
    charges?: number;
}

export class AppointmentForViewDto implements IAppointmentForViewDto {
    questionForViewDto?: QuestionForViewDto | undefined;
    appointmentDate?: string | undefined;
    appointmentTime?: string | undefined;
    status?: string | undefined;
    charges?: number;
    isPaid?: boolean;
    rejectedNote?: string | undefined;
    questionId?: number;

    constructor(data?: IAppointmentForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionForViewDto = _data["questionForViewDto"] ? QuestionForViewDto.fromJS(_data["questionForViewDto"]) : <any>undefined;
            this.appointmentDate = _data["appointmentDate"];
            this.appointmentTime = _data["appointmentTime"];
            this.status = _data["status"];
            this.charges = _data["charges"];
            this.isPaid = _data["isPaid"];
            this.rejectedNote = _data["rejectedNote"];
            this.questionId = _data["questionId"];
        }
    }

    static fromJS(data: any): AppointmentForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionForViewDto"] = this.questionForViewDto ? this.questionForViewDto.toJSON() : <any>undefined;
        data["appointmentDate"] = this.appointmentDate;
        data["appointmentTime"] = this.appointmentTime;
        data["status"] = this.status;
        data["charges"] = this.charges;
        data["isPaid"] = this.isPaid;
        data["rejectedNote"] = this.rejectedNote;
        data["questionId"] = this.questionId;
        return data; 
    }
}

export interface IAppointmentForViewDto {
    questionForViewDto?: QuestionForViewDto | undefined;
    appointmentDate?: string | undefined;
    appointmentTime?: string | undefined;
    status?: string | undefined;
    charges?: number;
    isPaid?: boolean;
    rejectedNote?: string | undefined;
    questionId?: number;
}

export class QuestionForViewDto implements IQuestionForViewDto {
    id?: number;
    mentorId?: number;
    menteeId?: number;
    mentorName?: string | undefined;
    menteeName?: string | undefined;
    mentorUserId?: string | undefined;
    menteeUserId?: string | undefined;
    departmentId?: number;
    categoryId?: number;
    subCategoryId?: number;
    profession?: string | undefined;
    questionDetail?: string | undefined;
    questionDate?: Date;
    questionTime?: Date;
    timeAgo?: string | undefined;
    audioFileId?: string | undefined;
    audioFileDescription?: string | undefined;
    status?: string | undefined;
    state?: string | undefined;
    answersCount?: number;
    questionAmount?: number;
    averageRating?: number;
    questionRating?: number;
    charges?: number;
    isPaid?: boolean;
    questionResponces?: QuestionResponceForViewDto[] | undefined;
    questionDocuments?: CreateOrEditQuestionDocumentDto[] | undefined;

    constructor(data?: IQuestionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mentorId = _data["mentorId"];
            this.menteeId = _data["menteeId"];
            this.mentorName = _data["mentorName"];
            this.menteeName = _data["menteeName"];
            this.mentorUserId = _data["mentorUserId"];
            this.menteeUserId = _data["menteeUserId"];
            this.departmentId = _data["departmentId"];
            this.categoryId = _data["categoryId"];
            this.subCategoryId = _data["subCategoryId"];
            this.profession = _data["profession"];
            this.questionDetail = _data["questionDetail"];
            this.questionDate = _data["questionDate"] ? new Date(_data["questionDate"].toString()) : <any>undefined;
            this.questionTime = _data["questionTime"] ? new Date(_data["questionTime"].toString()) : <any>undefined;
            this.timeAgo = _data["timeAgo"];
            this.audioFileId = _data["audioFileId"];
            this.audioFileDescription = _data["audioFileDescription"];
            this.status = _data["status"];
            this.state = _data["state"];
            this.answersCount = _data["answersCount"];
            this.questionAmount = _data["questionAmount"];
            this.averageRating = _data["averageRating"];
            this.questionRating = _data["questionRating"];
            this.charges = _data["charges"];
            this.isPaid = _data["isPaid"];
            if (Array.isArray(_data["questionResponces"])) {
                this.questionResponces = [] as any;
                for (let item of _data["questionResponces"])
                    this.questionResponces!.push(QuestionResponceForViewDto.fromJS(item));
            }
            if (Array.isArray(_data["questionDocuments"])) {
                this.questionDocuments = [] as any;
                for (let item of _data["questionDocuments"])
                    this.questionDocuments!.push(CreateOrEditQuestionDocumentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuestionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mentorId"] = this.mentorId;
        data["menteeId"] = this.menteeId;
        data["mentorName"] = this.mentorName;
        data["menteeName"] = this.menteeName;
        data["mentorUserId"] = this.mentorUserId;
        data["menteeUserId"] = this.menteeUserId;
        data["departmentId"] = this.departmentId;
        data["categoryId"] = this.categoryId;
        data["subCategoryId"] = this.subCategoryId;
        data["profession"] = this.profession;
        data["questionDetail"] = this.questionDetail;
        data["questionDate"] = this.questionDate ? this.questionDate.toISOString() : <any>undefined;
        data["questionTime"] = this.questionTime ? this.questionTime.toISOString() : <any>undefined;
        data["timeAgo"] = this.timeAgo;
        data["audioFileId"] = this.audioFileId;
        data["audioFileDescription"] = this.audioFileDescription;
        data["status"] = this.status;
        data["state"] = this.state;
        data["answersCount"] = this.answersCount;
        data["questionAmount"] = this.questionAmount;
        data["averageRating"] = this.averageRating;
        data["questionRating"] = this.questionRating;
        data["charges"] = this.charges;
        data["isPaid"] = this.isPaid;
        if (Array.isArray(this.questionResponces)) {
            data["questionResponces"] = [];
            for (let item of this.questionResponces)
                data["questionResponces"].push(item.toJSON());
        }
        if (Array.isArray(this.questionDocuments)) {
            data["questionDocuments"] = [];
            for (let item of this.questionDocuments)
                data["questionDocuments"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IQuestionForViewDto {
    id?: number;
    mentorId?: number;
    menteeId?: number;
    mentorName?: string | undefined;
    menteeName?: string | undefined;
    mentorUserId?: string | undefined;
    menteeUserId?: string | undefined;
    departmentId?: number;
    categoryId?: number;
    subCategoryId?: number;
    profession?: string | undefined;
    questionDetail?: string | undefined;
    questionDate?: Date;
    questionTime?: Date;
    timeAgo?: string | undefined;
    audioFileId?: string | undefined;
    audioFileDescription?: string | undefined;
    status?: string | undefined;
    state?: string | undefined;
    answersCount?: number;
    questionAmount?: number;
    averageRating?: number;
    questionRating?: number;
    charges?: number;
    isPaid?: boolean;
    questionResponces?: QuestionResponceForViewDto[] | undefined;
    questionDocuments?: CreateOrEditQuestionDocumentDto[] | undefined;
}

export class QuestionResponceForViewDto implements IQuestionResponceForViewDto {
    sequenceNo?: number;
    message?: string | undefined;
    messageDate?: Date;
    messageTime?: Date;
    timeAgo?: string | undefined;
    userId?: number;
    audioFileId?: string | undefined;
    audioFileDescription?: string | undefined;
    status?: string | undefined;
    profilePicture?: string | undefined;
    state?: string | undefined;

    constructor(data?: IQuestionResponceForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sequenceNo = _data["sequenceNo"];
            this.message = _data["message"];
            this.messageDate = _data["messageDate"] ? new Date(_data["messageDate"].toString()) : <any>undefined;
            this.messageTime = _data["messageTime"] ? new Date(_data["messageTime"].toString()) : <any>undefined;
            this.timeAgo = _data["timeAgo"];
            this.userId = _data["userId"];
            this.audioFileId = _data["audioFileId"];
            this.audioFileDescription = _data["audioFileDescription"];
            this.status = _data["status"];
            this.profilePicture = _data["profilePicture"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): QuestionResponceForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionResponceForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sequenceNo"] = this.sequenceNo;
        data["message"] = this.message;
        data["messageDate"] = this.messageDate ? this.messageDate.toISOString() : <any>undefined;
        data["messageTime"] = this.messageTime ? this.messageTime.toISOString() : <any>undefined;
        data["timeAgo"] = this.timeAgo;
        data["userId"] = this.userId;
        data["audioFileId"] = this.audioFileId;
        data["audioFileDescription"] = this.audioFileDescription;
        data["status"] = this.status;
        data["profilePicture"] = this.profilePicture;
        data["state"] = this.state;
        return data; 
    }
}

export interface IQuestionResponceForViewDto {
    sequenceNo?: number;
    message?: string | undefined;
    messageDate?: Date;
    messageTime?: Date;
    timeAgo?: string | undefined;
    userId?: number;
    audioFileId?: string | undefined;
    audioFileDescription?: string | undefined;
    status?: string | undefined;
    profilePicture?: string | undefined;
    state?: string | undefined;
}

export class CreateOrEditQuestionDocumentDto implements ICreateOrEditQuestionDocumentDto {
    documentid?: string | undefined;
    documentDescription?: string | undefined;

    constructor(data?: ICreateOrEditQuestionDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentid = _data["documentid"];
            this.documentDescription = _data["documentDescription"];
        }
    }

    static fromJS(data: any): CreateOrEditQuestionDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditQuestionDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentid"] = this.documentid;
        data["documentDescription"] = this.documentDescription;
        return data; 
    }
}

export interface ICreateOrEditQuestionDocumentDto {
    documentid?: string | undefined;
    documentDescription?: string | undefined;
}

export class CategoryDto implements ICategoryDto {
    id?: number;
    name?: string | undefined;
    departmentName?: string | undefined;

    constructor(data?: ICategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.departmentName = _data["departmentName"];
        }
    }

    static fromJS(data: any): CategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["departmentName"] = this.departmentName;
        return data; 
    }
}

export interface ICategoryDto {
    id?: number;
    name?: string | undefined;
    departmentName?: string | undefined;
}

export class CatgoryDtOForEdit implements ICatgoryDtOForEdit {
    id?: number;
    name?: string | undefined;
    departmentId?: number;

    constructor(data?: ICatgoryDtOForEdit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.departmentId = _data["departmentId"];
        }
    }

    static fromJS(data: any): CatgoryDtOForEdit {
        data = typeof data === 'object' ? data : {};
        let result = new CatgoryDtOForEdit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["departmentId"] = this.departmentId;
        return data; 
    }
}

export interface ICatgoryDtOForEdit {
    id?: number;
    name?: string | undefined;
    departmentId?: number;
}

export class SubCategoryForViewDtocs implements ISubCategoryForViewDtocs {
    id?: number | undefined;
    name?: string | undefined;
    categoryId?: number;
    categoryName?: string | undefined;

    constructor(data?: ISubCategoryForViewDtocs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.categoryId = _data["categoryId"];
            this.categoryName = _data["categoryName"];
        }
    }

    static fromJS(data: any): SubCategoryForViewDtocs {
        data = typeof data === 'object' ? data : {};
        let result = new SubCategoryForViewDtocs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["categoryId"] = this.categoryId;
        data["categoryName"] = this.categoryName;
        return data; 
    }
}

export interface ISubCategoryForViewDtocs {
    id?: number | undefined;
    name?: string | undefined;
    categoryId?: number;
    categoryName?: string | undefined;
}

export class CreateOrUpdateSubCategoryDto implements ICreateOrUpdateSubCategoryDto {
    id?: number | undefined;
    name?: string | undefined;
    categoryId?: number;

    constructor(data?: ICreateOrUpdateSubCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.categoryId = _data["categoryId"];
        }
    }

    static fromJS(data: any): CreateOrUpdateSubCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateSubCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["categoryId"] = this.categoryId;
        return data; 
    }
}

export interface ICreateOrUpdateSubCategoryDto {
    id?: number | undefined;
    name?: string | undefined;
    categoryId?: number;
}

export class SubCategoryForEditDto implements ISubCategoryForEditDto {
    id?: number | undefined;
    name?: string | undefined;
    categoryId?: number;
    departmentID?: number | undefined;

    constructor(data?: ISubCategoryForEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.categoryId = _data["categoryId"];
            this.departmentID = _data["departmentID"];
        }
    }

    static fromJS(data: any): SubCategoryForEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubCategoryForEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["categoryId"] = this.categoryId;
        data["departmentID"] = this.departmentID;
        return data; 
    }
}

export interface ISubCategoryForEditDto {
    id?: number | undefined;
    name?: string | undefined;
    categoryId?: number;
    departmentID?: number | undefined;
}

export class DashboardViewDto implements IDashboardViewDto {
    totalQuestions?: number;
    todayQuestions?: number;
    completedQuestions?: number;
    totalAppointments?: number;
    todayAppointments?: number;
    pendingQuestions?: number;
    pendingAppointments?: number;
    upcomingAppointments?: number;

    constructor(data?: IDashboardViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalQuestions = _data["totalQuestions"];
            this.todayQuestions = _data["todayQuestions"];
            this.completedQuestions = _data["completedQuestions"];
            this.totalAppointments = _data["totalAppointments"];
            this.todayAppointments = _data["todayAppointments"];
            this.pendingQuestions = _data["pendingQuestions"];
            this.pendingAppointments = _data["pendingAppointments"];
            this.upcomingAppointments = _data["upcomingAppointments"];
        }
    }

    static fromJS(data: any): DashboardViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalQuestions"] = this.totalQuestions;
        data["todayQuestions"] = this.todayQuestions;
        data["completedQuestions"] = this.completedQuestions;
        data["totalAppointments"] = this.totalAppointments;
        data["todayAppointments"] = this.todayAppointments;
        data["pendingQuestions"] = this.pendingQuestions;
        data["pendingAppointments"] = this.pendingAppointments;
        data["upcomingAppointments"] = this.upcomingAppointments;
        return data; 
    }
}

export interface IDashboardViewDto {
    totalQuestions?: number;
    todayQuestions?: number;
    completedQuestions?: number;
    totalAppointments?: number;
    todayAppointments?: number;
    pendingQuestions?: number;
    pendingAppointments?: number;
    upcomingAppointments?: number;
}

export class CreateOrEditDepartment implements ICreateOrEditDepartment {
    id?: number;
    name?: string | undefined;

    constructor(data?: ICreateOrEditDepartment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateOrEditDepartment {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditDepartment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface ICreateOrEditDepartment {
    id?: number;
    name?: string | undefined;
}

export class InvoiceDto implements IInvoiceDto {
    invoiceNo?: string | undefined;
    created?: Date;
    from?: string | undefined;
    fromAddressLine1?: string | undefined;
    fromAddressLine2?: string | undefined;
    to?: string | undefined;
    toAddressLine1?: string | undefined;
    toAddressLine2?: string | undefined;
    paymentMethod?: string | undefined;
    description?: string | undefined;
    quantity?: number;
    charges?: number;
    subTotal?: number;
    totalAmount?: number;
    paymentNote?: string | undefined;

    constructor(data?: IInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceNo = _data["invoiceNo"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.from = _data["from"];
            this.fromAddressLine1 = _data["fromAddressLine1"];
            this.fromAddressLine2 = _data["fromAddressLine2"];
            this.to = _data["to"];
            this.toAddressLine1 = _data["toAddressLine1"];
            this.toAddressLine2 = _data["toAddressLine2"];
            this.paymentMethod = _data["paymentMethod"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.charges = _data["charges"];
            this.subTotal = _data["subTotal"];
            this.totalAmount = _data["totalAmount"];
            this.paymentNote = _data["paymentNote"];
        }
    }

    static fromJS(data: any): InvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceNo"] = this.invoiceNo;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["from"] = this.from;
        data["fromAddressLine1"] = this.fromAddressLine1;
        data["fromAddressLine2"] = this.fromAddressLine2;
        data["to"] = this.to;
        data["toAddressLine1"] = this.toAddressLine1;
        data["toAddressLine2"] = this.toAddressLine2;
        data["paymentMethod"] = this.paymentMethod;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["charges"] = this.charges;
        data["subTotal"] = this.subTotal;
        data["totalAmount"] = this.totalAmount;
        data["paymentNote"] = this.paymentNote;
        return data; 
    }
}

export interface IInvoiceDto {
    invoiceNo?: string | undefined;
    created?: Date;
    from?: string | undefined;
    fromAddressLine1?: string | undefined;
    fromAddressLine2?: string | undefined;
    to?: string | undefined;
    toAddressLine1?: string | undefined;
    toAddressLine2?: string | undefined;
    paymentMethod?: string | undefined;
    description?: string | undefined;
    quantity?: number;
    charges?: number;
    subTotal?: number;
    totalAmount?: number;
    paymentNote?: string | undefined;
}

export class PaymentGatewayModel implements IPaymentGatewayModel {
    gatewayType?: SubscriptionPaymentGatewayType;
    supportsRecurringPayments?: boolean;

    constructor(data?: IPaymentGatewayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gatewayType = _data["gatewayType"];
            this.supportsRecurringPayments = _data["supportsRecurringPayments"];
        }
    }

    static fromJS(data: any): PaymentGatewayModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentGatewayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gatewayType"] = this.gatewayType;
        data["supportsRecurringPayments"] = this.supportsRecurringPayments;
        return data; 
    }
}

export interface IPaymentGatewayModel {
    gatewayType?: SubscriptionPaymentGatewayType;
    supportsRecurringPayments?: boolean;
}

export class CreateQuestionCommand implements ICreateQuestionCommand {
    createOrEditQuestionDto?: CreateOrEditQuestionDto | undefined;

    constructor(data?: ICreateQuestionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createOrEditQuestionDto = _data["createOrEditQuestionDto"] ? CreateOrEditQuestionDto.fromJS(_data["createOrEditQuestionDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateQuestionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateQuestionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createOrEditQuestionDto"] = this.createOrEditQuestionDto ? this.createOrEditQuestionDto.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICreateQuestionCommand {
    createOrEditQuestionDto?: CreateOrEditQuestionDto | undefined;
}

export class CreateOrEditQuestionDto implements ICreateOrEditQuestionDto {
    id?: number;
    mentorId?: number;
    menteeId?: number;
    departmentId?: number;
    categoryId?: number;
    subCategoryId?: number;
    questionDetail?: string | undefined;
    questionType?: string | undefined;
    questionDate?: Date;
    audioFileId?: string | undefined;
    audioFileDescription?: string | undefined;
    status?: string | undefined;
    questionDocuments?: CreateOrEditQuestionDocumentDto[] | undefined;

    constructor(data?: ICreateOrEditQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mentorId = _data["mentorId"];
            this.menteeId = _data["menteeId"];
            this.departmentId = _data["departmentId"];
            this.categoryId = _data["categoryId"];
            this.subCategoryId = _data["subCategoryId"];
            this.questionDetail = _data["questionDetail"];
            this.questionType = _data["questionType"];
            this.questionDate = _data["questionDate"] ? new Date(_data["questionDate"].toString()) : <any>undefined;
            this.audioFileId = _data["audioFileId"];
            this.audioFileDescription = _data["audioFileDescription"];
            this.status = _data["status"];
            if (Array.isArray(_data["questionDocuments"])) {
                this.questionDocuments = [] as any;
                for (let item of _data["questionDocuments"])
                    this.questionDocuments!.push(CreateOrEditQuestionDocumentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrEditQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditQuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mentorId"] = this.mentorId;
        data["menteeId"] = this.menteeId;
        data["departmentId"] = this.departmentId;
        data["categoryId"] = this.categoryId;
        data["subCategoryId"] = this.subCategoryId;
        data["questionDetail"] = this.questionDetail;
        data["questionType"] = this.questionType;
        data["questionDate"] = this.questionDate ? this.questionDate.toISOString() : <any>undefined;
        data["audioFileId"] = this.audioFileId;
        data["audioFileDescription"] = this.audioFileDescription;
        data["status"] = this.status;
        if (Array.isArray(this.questionDocuments)) {
            data["questionDocuments"] = [];
            for (let item of this.questionDocuments)
                data["questionDocuments"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateOrEditQuestionDto {
    id?: number;
    mentorId?: number;
    menteeId?: number;
    departmentId?: number;
    categoryId?: number;
    subCategoryId?: number;
    questionDetail?: string | undefined;
    questionType?: string | undefined;
    questionDate?: Date;
    audioFileId?: string | undefined;
    audioFileDescription?: string | undefined;
    status?: string | undefined;
    questionDocuments?: CreateOrEditQuestionDocumentDto[] | undefined;
}

export class UpdateQuestionCommand implements IUpdateQuestionCommand {
    createOrEditQuestionDto?: CreateOrEditQuestionDto | undefined;

    constructor(data?: IUpdateQuestionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createOrEditQuestionDto = _data["createOrEditQuestionDto"] ? CreateOrEditQuestionDto.fromJS(_data["createOrEditQuestionDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateQuestionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateQuestionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createOrEditQuestionDto"] = this.createOrEditQuestionDto ? this.createOrEditQuestionDto.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUpdateQuestionCommand {
    createOrEditQuestionDto?: CreateOrEditQuestionDto | undefined;
}

export class QuestionDto implements IQuestionDto {
    id?: number;
    mentorId?: number;
    mentor?: MentorDto | undefined;

    constructor(data?: IQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mentorId = _data["mentorId"];
            this.mentor = _data["mentor"] ? MentorDto.fromJS(_data["mentor"]) : <any>undefined;
        }
    }

    static fromJS(data: any): QuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mentorId"] = this.mentorId;
        data["mentor"] = this.mentor ? this.mentor.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IQuestionDto {
    id?: number;
    mentorId?: number;
    mentor?: MentorDto | undefined;
}

export class SelectMentorQuestionCommand implements ISelectMentorQuestionCommand {
    question?: QuestionDto | undefined;

    constructor(data?: ISelectMentorQuestionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.question = _data["question"] ? QuestionDto.fromJS(_data["question"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SelectMentorQuestionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SelectMentorQuestionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["question"] = this.question ? this.question.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ISelectMentorQuestionCommand {
    question?: QuestionDto | undefined;
}

export class CreateQuestionResponceCommand implements ICreateQuestionResponceCommand {
    createOrEditQuestionResponceDto?: CreateOrEditQuestionResponceDto | undefined;

    constructor(data?: ICreateQuestionResponceCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createOrEditQuestionResponceDto = _data["createOrEditQuestionResponceDto"] ? CreateOrEditQuestionResponceDto.fromJS(_data["createOrEditQuestionResponceDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateQuestionResponceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateQuestionResponceCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createOrEditQuestionResponceDto"] = this.createOrEditQuestionResponceDto ? this.createOrEditQuestionResponceDto.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICreateQuestionResponceCommand {
    createOrEditQuestionResponceDto?: CreateOrEditQuestionResponceDto | undefined;
}

export class CreateOrEditQuestionResponceDto implements ICreateOrEditQuestionResponceDto {
    id?: number;
    questionId?: number;
    message?: string | undefined;
    messageDate?: Date;
    messageTime?: Date;
    userId?: number;
    audioFileId?: string | undefined;
    audioFileDescription?: string | undefined;
    status?: string | undefined;

    constructor(data?: ICreateOrEditQuestionResponceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.questionId = _data["questionId"];
            this.message = _data["message"];
            this.messageDate = _data["messageDate"] ? new Date(_data["messageDate"].toString()) : <any>undefined;
            this.messageTime = _data["messageTime"] ? new Date(_data["messageTime"].toString()) : <any>undefined;
            this.userId = _data["userId"];
            this.audioFileId = _data["audioFileId"];
            this.audioFileDescription = _data["audioFileDescription"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CreateOrEditQuestionResponceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditQuestionResponceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["questionId"] = this.questionId;
        data["message"] = this.message;
        data["messageDate"] = this.messageDate ? this.messageDate.toISOString() : <any>undefined;
        data["messageTime"] = this.messageTime ? this.messageTime.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["audioFileId"] = this.audioFileId;
        data["audioFileDescription"] = this.audioFileDescription;
        data["status"] = this.status;
        return data; 
    }
}

export interface ICreateOrEditQuestionResponceDto {
    id?: number;
    questionId?: number;
    message?: string | undefined;
    messageDate?: Date;
    messageTime?: Date;
    userId?: number;
    audioFileId?: string | undefined;
    audioFileDescription?: string | undefined;
    status?: string | undefined;
}

export class QuestionViewDto implements IQuestionViewDto {
    id?: number;
    mentorId?: number;
    menteeId?: number;
    mentorName?: string | undefined;
    menteeName?: string | undefined;
    mentorUserId?: string | undefined;
    menteeUserId?: string | undefined;
    departmentId?: number;
    categoryId?: number;
    subCategoryId?: number;
    profession?: string | undefined;
    questionDetail?: string | undefined;
    questionDate?: Date;
    questionTime?: Date;
    timeAgo?: string | undefined;
    audioFileId?: string | undefined;
    audioFileDescription?: string | undefined;
    status?: string | undefined;
    state?: string | undefined;
    answersCount?: number;
    questionAmount?: number;
    averageRating?: number;
    questionRating?: number;
    mentorProfileDate?: string | undefined;
    menteeProfileDate?: string | undefined;

    constructor(data?: IQuestionViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mentorId = _data["mentorId"];
            this.menteeId = _data["menteeId"];
            this.mentorName = _data["mentorName"];
            this.menteeName = _data["menteeName"];
            this.mentorUserId = _data["mentorUserId"];
            this.menteeUserId = _data["menteeUserId"];
            this.departmentId = _data["departmentId"];
            this.categoryId = _data["categoryId"];
            this.subCategoryId = _data["subCategoryId"];
            this.profession = _data["profession"];
            this.questionDetail = _data["questionDetail"];
            this.questionDate = _data["questionDate"] ? new Date(_data["questionDate"].toString()) : <any>undefined;
            this.questionTime = _data["questionTime"] ? new Date(_data["questionTime"].toString()) : <any>undefined;
            this.timeAgo = _data["timeAgo"];
            this.audioFileId = _data["audioFileId"];
            this.audioFileDescription = _data["audioFileDescription"];
            this.status = _data["status"];
            this.state = _data["state"];
            this.answersCount = _data["answersCount"];
            this.questionAmount = _data["questionAmount"];
            this.averageRating = _data["averageRating"];
            this.questionRating = _data["questionRating"];
            this.mentorProfileDate = _data["mentorProfileDate"];
            this.menteeProfileDate = _data["menteeProfileDate"];
        }
    }

    static fromJS(data: any): QuestionViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mentorId"] = this.mentorId;
        data["menteeId"] = this.menteeId;
        data["mentorName"] = this.mentorName;
        data["menteeName"] = this.menteeName;
        data["mentorUserId"] = this.mentorUserId;
        data["menteeUserId"] = this.menteeUserId;
        data["departmentId"] = this.departmentId;
        data["categoryId"] = this.categoryId;
        data["subCategoryId"] = this.subCategoryId;
        data["profession"] = this.profession;
        data["questionDetail"] = this.questionDetail;
        data["questionDate"] = this.questionDate ? this.questionDate.toISOString() : <any>undefined;
        data["questionTime"] = this.questionTime ? this.questionTime.toISOString() : <any>undefined;
        data["timeAgo"] = this.timeAgo;
        data["audioFileId"] = this.audioFileId;
        data["audioFileDescription"] = this.audioFileDescription;
        data["status"] = this.status;
        data["state"] = this.state;
        data["answersCount"] = this.answersCount;
        data["questionAmount"] = this.questionAmount;
        data["averageRating"] = this.averageRating;
        data["questionRating"] = this.questionRating;
        data["mentorProfileDate"] = this.mentorProfileDate;
        data["menteeProfileDate"] = this.menteeProfileDate;
        return data; 
    }
}

export interface IQuestionViewDto {
    id?: number;
    mentorId?: number;
    menteeId?: number;
    mentorName?: string | undefined;
    menteeName?: string | undefined;
    mentorUserId?: string | undefined;
    menteeUserId?: string | undefined;
    departmentId?: number;
    categoryId?: number;
    subCategoryId?: number;
    profession?: string | undefined;
    questionDetail?: string | undefined;
    questionDate?: Date;
    questionTime?: Date;
    timeAgo?: string | undefined;
    audioFileId?: string | undefined;
    audioFileDescription?: string | undefined;
    status?: string | undefined;
    state?: string | undefined;
    answersCount?: number;
    questionAmount?: number;
    averageRating?: number;
    questionRating?: number;
    mentorProfileDate?: string | undefined;
    menteeProfileDate?: string | undefined;
}

export class CreateTodoItemCommand implements ICreateTodoItemCommand {
    listId?: number;
    title?: string | undefined;

    constructor(data?: ICreateTodoItemCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.listId = _data["listId"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): CreateTodoItemCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTodoItemCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listId"] = this.listId;
        data["title"] = this.title;
        return data; 
    }
}

export interface ICreateTodoItemCommand {
    listId?: number;
    title?: string | undefined;
}

export class UpdateTodoItemCommand implements IUpdateTodoItemCommand {
    id?: number;
    title?: string | undefined;
    done?: boolean;

    constructor(data?: IUpdateTodoItemCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.done = _data["done"];
        }
    }

    static fromJS(data: any): UpdateTodoItemCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTodoItemCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["done"] = this.done;
        return data; 
    }
}

export interface IUpdateTodoItemCommand {
    id?: number;
    title?: string | undefined;
    done?: boolean;
}

export class UpdateTodoItemDetailCommand implements IUpdateTodoItemDetailCommand {
    id?: number;
    listId?: number;
    priority?: PriorityLevel;
    note?: string | undefined;

    constructor(data?: IUpdateTodoItemDetailCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.listId = _data["listId"];
            this.priority = _data["priority"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UpdateTodoItemDetailCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTodoItemDetailCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["listId"] = this.listId;
        data["priority"] = this.priority;
        data["note"] = this.note;
        return data; 
    }
}

export interface IUpdateTodoItemDetailCommand {
    id?: number;
    listId?: number;
    priority?: PriorityLevel;
    note?: string | undefined;
}

export enum PriorityLevel {
    None = 0,
    Low = 1,
    Medium = 2,
    High = 3,
}

export class TodosVm implements ITodosVm {
    priorityLevels?: PriorityLevelDto[] | undefined;
    lists?: TodoListDto[] | undefined;

    constructor(data?: ITodosVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["priorityLevels"])) {
                this.priorityLevels = [] as any;
                for (let item of _data["priorityLevels"])
                    this.priorityLevels!.push(PriorityLevelDto.fromJS(item));
            }
            if (Array.isArray(_data["lists"])) {
                this.lists = [] as any;
                for (let item of _data["lists"])
                    this.lists!.push(TodoListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TodosVm {
        data = typeof data === 'object' ? data : {};
        let result = new TodosVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.priorityLevels)) {
            data["priorityLevels"] = [];
            for (let item of this.priorityLevels)
                data["priorityLevels"].push(item.toJSON());
        }
        if (Array.isArray(this.lists)) {
            data["lists"] = [];
            for (let item of this.lists)
                data["lists"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITodosVm {
    priorityLevels?: PriorityLevelDto[] | undefined;
    lists?: TodoListDto[] | undefined;
}

export class PriorityLevelDto implements IPriorityLevelDto {
    value?: number;
    name?: string | undefined;

    constructor(data?: IPriorityLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PriorityLevelDto {
        data = typeof data === 'object' ? data : {};
        let result = new PriorityLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["name"] = this.name;
        return data; 
    }
}

export interface IPriorityLevelDto {
    value?: number;
    name?: string | undefined;
}

export class TodoListDto implements ITodoListDto {
    id?: number;
    title?: string | undefined;
    items?: TodoItemDto[] | undefined;

    constructor(data?: ITodoListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TodoItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TodoListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TodoListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITodoListDto {
    id?: number;
    title?: string | undefined;
    items?: TodoItemDto[] | undefined;
}

export class TodoItemDto implements ITodoItemDto {
    id?: number;
    listId?: number;
    title?: string | undefined;
    done?: boolean;
    priority?: number;
    note?: string | undefined;

    constructor(data?: ITodoItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.listId = _data["listId"];
            this.title = _data["title"];
            this.done = _data["done"];
            this.priority = _data["priority"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): TodoItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new TodoItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["listId"] = this.listId;
        data["title"] = this.title;
        data["done"] = this.done;
        data["priority"] = this.priority;
        data["note"] = this.note;
        return data; 
    }
}

export interface ITodoItemDto {
    id?: number;
    listId?: number;
    title?: string | undefined;
    done?: boolean;
    priority?: number;
    note?: string | undefined;
}

export class CreateTodoListCommand implements ICreateTodoListCommand {
    title?: string | undefined;

    constructor(data?: ICreateTodoListCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): CreateTodoListCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTodoListCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        return data; 
    }
}

export interface ICreateTodoListCommand {
    title?: string | undefined;
}

export class UpdateTodoListCommand implements IUpdateTodoListCommand {
    id?: number;
    title?: string | undefined;

    constructor(data?: IUpdateTodoListCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): UpdateTodoListCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTodoListCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        return data; 
    }
}

export interface IUpdateTodoListCommand {
    id?: number;
    title?: string | undefined;
}

export class WeatherForecast implements IWeatherForecast {
    date?: Date;
    temperatureC?: number;
    temperatureF?: number;
    summary?: string | undefined;

    constructor(data?: IWeatherForecast) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.temperatureC = _data["temperatureC"];
            this.temperatureF = _data["temperatureF"];
            this.summary = _data["summary"];
        }
    }

    static fromJS(data: any): WeatherForecast {
        data = typeof data === 'object' ? data : {};
        let result = new WeatherForecast();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["temperatureC"] = this.temperatureC;
        data["temperatureF"] = this.temperatureF;
        data["summary"] = this.summary;
        return data; 
    }
}

export interface IWeatherForecast {
    date?: Date;
    temperatureC?: number;
    temperatureF?: number;
    summary?: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}